/**
 * Wizard variant grid / lightbox / ATC (from flow.attach).
 * Called after state exists so qty/ATC keep the same bindings.
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlowVariants) return;
  global.WorkshopBookingWizardFlowVariants = {
    attach: function (S) {
      if (!S) return;
      var Flow = S.Flow;
      var addonVariantIdKey = S.addonVariantIdKey;
      var addonVariantObject = S.addonVariantObject;
      var animateCarouselScrollLeft = S.animateCarouselScrollLeft;
      var applyVariantCarouselLayout = S.applyVariantCarouselLayout;
      var bindVariantGridResize = S.bindVariantGridResize;
      var bookingRoot = S.bookingRoot;
      var carouselSlideScrollLeft = S.carouselSlideScrollLeft;
      var getCarouselOffset = S.getCarouselOffset;
      var prepareVariantCarouselMount = S.prepareVariantCarouselMount;
      var setCarouselOffset = S.setCarouselOffset;
      var closeImpulseProductZoom = S.closeImpulseProductZoom;
      var closePrettySelects = S.closePrettySelects;
      var closeWizardWaitlistModal = S.closeWizardWaitlistModal;
      var data = S.data;
      var enhancePopupSelect = S.enhancePopupSelect;
      var ensureVariantMediaMeta = S.ensureVariantMediaMeta;
      var escapeHtml = S.escapeHtml;
      var fillDateSelectOptions = S.fillDateSelectOptions;
      var fillPopupTimeSelect = S.fillPopupTimeSelect;
      var findSlotForTimeValue = S.findSlotForTimeValue;
      var formatBookingSubLabel = S.formatBookingSubLabel;
      var formatMoney = S.formatMoney;
      var formatPopupDateLabel = S.formatPopupDateLabel;
      var formatSessionTimeRange = S.formatSessionTimeRange;
      var formatSlotOptionText = S.formatSlotOptionText;
      var getLiveApi = S.getLiveApi;
      var getSectionRoot = S.getSectionRoot;
      var isAddonVariantId = S.isAddonVariantId;
      var isMobileViewport = S.isMobileViewport;
      var isStoreVenue = S.isStoreVenue;
      var liveController = S.liveController;
      var liveFlags = S.liveFlags;
      var normalizeOptionValue = S.normalizeOptionValue;
      var parseVariantsJson = S.parseVariantsJson;
      var parseZoomSlideMediaId = S.parseZoomSlideMediaId;
      var parseZoomThumbMediaId = S.parseZoomThumbMediaId;
      var popupDateSelect = S.popupDateSelect;
      var popupTimeSelect = S.popupTimeSelect;
      var resolveVariantPriceCents = S.resolveVariantPriceCents;
      var resolveWaitlistWorkshopType = S.resolveWaitlistWorkshopType;
      var setBranch = S.setBranch;
      var clearVenueSelection = S.clearVenueSelection;
      var sectionId = S.sectionId;
      var setPopupDatetimeHint = S.setPopupDatetimeHint;
      var slotBookable = S.slotBookable;
      var slotDateKey = S.slotDateKey;
      var slotHidden = S.slotHidden;
      var slotSoldOut = S.slotSoldOut;
      var slotsForDate = S.slotsForDate;
      var splitFullName = S.splitFullName;
      var state = S.state;
      var stepEl = S.stepEl;
      var styleValueFromVariant = S.styleValueFromVariant;
      var sweepViewMonthLive = S.sweepViewMonthLive;
      var syncBookingUrlVariantOnStep3 = S.syncBookingUrlVariantOnStep3;
      var syncPopupSelectFilled = S.syncPopupSelectFilled;
      var syncPrettySelect = S.syncPrettySelect;
      var syncSiblingWorkshopPromo = S.syncSiblingWorkshopPromo;
      var syncVariantToPdp = S.syncVariantToPdp;
      var toIsoDateKey = S.toIsoDateKey;
      var uniquePopupDateKeys = S.uniquePopupDateKeys;
      var vQtyKey = S.vQtyKey;
      var variantQtyControlHtml = S.variantQtyControlHtml;
      var variants = S.variants;
      var wbwAddonDisplayTitle = S.wbwAddonDisplayTitle;
      var wizardRoot = S.wizardRoot;

    function totalVariantQty(includeAddon) {
      var n = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        if (!includeAddon && isAddonVariantId(k)) return;
        n += state.variantQty[k] || 0;
      });
      return n;
    }

    function hasSelectedVariants() {
      return totalVariantQty(false) > 0;
    }

    function ensureSeedVariantQty() {
      if (hasSelectedVariants()) return false;
      if (!state.selectedSlot || !slotBookable(state.selectedSlot)) return false;
      var id = vQtyKey(state.focusedVariantId || state.lockedVariantId || '');
      if (!id || isAddonVariantId(id) || !findWizardVariant(id)) {
        var first = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i] && !variants[i]._isAddon) {
            first = variants[i];
            break;
          }
        }
        id = first ? vQtyKey(first.id) : '';
      }
      if (!id || isAddonVariantId(id) || !findWizardVariant(id)) return false;
      state.variantQty[id] = 1;
      if (!state.focusedVariantId) state.focusedVariantId = id;
      if (!state.lockedVariantId) state.lockedVariantId = id;
      return true;
    }

    function selectedDesignIds() {
      var ids = [];
      Object.keys(state.variantQty).forEach(function (k) {
        if (isAddonVariantId(k) || !(state.variantQty[k] > 0)) return;
        ids.push(k);
      });
      return ids;
    }

    function variantWhenKind(id) {
      var saved = state.variantWhen[vQtyKey(id)];
      if (saved && saved.gid) {
        var pinned = findSlotBySyncKey(saved.gid);
        if (pinned && slotBookable(pinned)) return 'ready';
        if (pinned && slotSoldOut(pinned)) return 'soldout';
        return 'unavailable';
      }
      var s = state.selectedSlot;
      if (s && slotBookable(s)) return 'ready';
      if (s && slotSoldOut(s)) return 'soldout';
      if (s) return 'unavailable';
      return 'missing';
    }

    function hasDateWithoutTime() {
      if (state.selectedDate && !state.selectedSlot) return true;
      var box = document.querySelector('[data-wbw-lightbox]');
      if (box) {
        var lbDate = box.querySelector('[data-wbw-lb-date]');
        var lbTime = box.querySelector('[data-wbw-lb-time]');
        if (lbDate && String(lbDate.value || '').trim() && (!lbTime || !String(lbTime.value || '').trim())) {
          return true;
        }
      }
      var any = false;
      Object.keys(state.variantWhen || {}).forEach(function (k) {
        var w = state.variantWhen[k];
        if (w && w.dateKey && !w.gid) any = true;
      });
      return any;
    }

    function atcReminderText() {
      var ids = selectedDesignIds();
      if (!ids.length) return '';

      var missing = 0;
      var soldout = 0;
      var unavailable = 0;
      var ready = 0;
      ids.forEach(function (id) {
        var kind = variantWhenKind(id);
        if (kind === 'ready') ready += 1;
        else if (kind === 'soldout') soldout += 1;
        else if (kind === 'unavailable') unavailable += 1;
        else missing += 1;
      });
      if (!missing && !soldout && !unavailable) return '';
      if (soldout && !missing && !unavailable) {
        return ready || soldout > 1
          ? 'A selected session is sold out — pick another time'
          : 'This session is sold out — pick another time';
      }
      if ((unavailable || soldout) && !missing) {
        return ready || unavailable + soldout > 1
          ? 'A selected time isn’t available — pick another'
          : 'This time isn’t available — pick another';
      }
      if (missing && ready) return 'Don’t forget the date & time';
      if (hasDateWithoutTime()) return 'Don’t forget the time';
      return 'Don’t forget the date & time';
    }

    function setAtcHint(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    var WBW_CART_SOLD_OUT_MSG =
      'Check your cart — a sold-out workshop must be removed before you can add this item.';

    function isCartCrossContaminationNotice(msg) {
      return /already have seats|remove.*cart|remove it to continue|checkout is paused|this workshop is sold out/i.test(
        String(msg || '')
      );
    }

    function showWizardNotice(msg, opts) {
      opts = opts || {};
      msg = String(msg || '').trim();
      if (!msg) return;
      state._wbwStickyNotice = msg;
      syncAtcReminder();
    }

    function clearWizardNotice() {
      if (!state._wbwStickyNotice) return;
      state._wbwStickyNotice = '';
      syncAtcReminder();
    }

    function rewriteAtcFailMessage(failMsg, slotForVerdict) {
      failMsg =
        String(failMsg || '').trim() ||
        'This workshop event is no longer available. Please select a different time.';
      if (slotForVerdict && slotSoldOut(slotForVerdict)) {
        return 'This session is sold out — pick another time';
      }
      if (
        slotForVerdict &&
        slotBookable(slotForVerdict) &&
        !slotSoldOut(slotForVerdict) &&
        isCartCrossContaminationNotice(failMsg)
      ) {
        return WBW_CART_SOLD_OUT_MSG;
      }
      return failMsg;
    }

    function checkCartSoldOutBeforeAdd(cart) {
      var guard = global.WorkshopCartCapacityGuard;
      if (!guard || typeof guard.validateCart !== 'function') {
        return Promise.resolve(null);
      }
      return Promise.resolve(guard.validateCart(cart, 'checkout')).then(function (verdict) {
        if (!verdict || verdict.allowed !== false || !wizardSelectionIsBookable()) return null;
        var issues = Array.isArray(verdict.issues) ? verdict.issues : [];
        var hasSoldOut = issues.some(function (issue) {
          return issue && issue.reason === 'sold_out';
        });
        if (!hasSoldOut) return null;
        return WBW_CART_SOLD_OUT_MSG;
      });
    }

    function wizardSelectionIsBookable() {
      if (!hasSelectedVariants()) return false;
      return allSelectedVariantsHaveSlot();
    }

    function clearStaleWizardCapacityNotice() {
      if (!state._wbwStickyNotice) return;
      if (!isCartCrossContaminationNotice(state._wbwStickyNotice)) return;
      if (wizardSelectionIsBookable()) clearWizardNotice();
    }

    function datetimeContinueReminder() {
      if (state.selectedSlot && slotBookable(state.selectedSlot)) return '';
      if (!state.selectedDate) return '';
      if (!state.selectedSlot) return 'Don’t forget the time';
      if (slotSoldOut(state.selectedSlot)) return 'This session is sold out — pick another time';
      return 'This time isn’t available — pick another';
    }

    function syncAtcReminder() {
      var sticky = String(state._wbwStickyNotice || '').trim();
      var mainText = sticky || atcReminderText();
      wizardRoot.querySelectorAll('[data-wbw-atc-hint]').forEach(function (el) {
        if (el.closest('[data-wbw-lightbox]')) return;
        setAtcHint(el, mainText);
        el.classList.toggle('is-error', !!sticky);
      });
      setAtcHint(wizardRoot.querySelector('[data-wbw-cta-hint="venue"]'), '');
      setAtcHint(wizardRoot.querySelector('[data-wbw-cta-hint="datetime"]'), datetimeContinueReminder());
      var box = document.querySelector('[data-wbw-lightbox]');
      if (!box) return;
      var lbHint = box.querySelector('[data-wbw-atc-hint]');
      setAtcHint(lbHint, sticky || atcReminderText());
      if (lbHint) lbHint.classList.toggle('is-error', !!sticky);
    }

    /** Every selected design must resolve to a bookable slot (its own or the shared one). */
    function allSelectedVariantsHaveSlot() {
      var ok = true;
      var any = false;
      Object.keys(state.variantQty).forEach(function (k) {
        if (isAddonVariantId(k) || !(state.variantQty[k] > 0)) return;
        any = true;
        var s = resolveVariantSlot(k);
        if (!s || !slotBookable(s)) ok = false;
      });
      return any && ok;
    }

    /** Seats left for selected event — from capacity_remaining only (per event, no fixed cap). */
    function parseSlotCapacityRemaining(slot) {
      if (!slot) return null;
      var cap = slot.capacity_remaining;
      if (cap == null || cap === '') {
        var raw = slot._raw;
        if (raw && raw.capacity_remaining != null && raw.capacity_remaining !== '') {
          cap = raw.capacity_remaining;
        }
      }
      if (cap == null || cap === '') return null;
      var n = Number(cap);
      return Number.isFinite(n) ? n : null;
    }

    function maxBookableQty() {
      if (!state.selectedSlot) {
        /* Popup step: allow picking styles before date/time; ATC still requires a slot. */
        if (state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking') {
          return 99;
        }
        return 0;
      }
      if (!slotBookable(state.selectedSlot)) return 0;
      if (liveController && typeof liveController.maxBookableQty === 'function') {
        return liveController.maxBookableQty(state.selectedSlot);
      }
      var cap = parseSlotCapacityRemaining(state.selectedSlot);
      if (cap == null) return 1;
      return cap > 0 ? cap : 0;
    }

    function formatWizardVariantPricesOuter(v, slotForPrice) {
      var slot = slotForPrice !== undefined ? slotForPrice : state.selectedSlot;
      var open =
        slotBookable(slot) ||
        (!slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking');
      var base = Number(v && v.price) || 0;
      var compareAt = Number(v && (v.compare_at_price != null ? v.compare_at_price : v.compareAtPrice)) || 0;
      var resolved = resolveVariantPriceCents(v, slot);
      /* Prefer Shopify compare-at; else show base when workshop pricing discounted it. */
      var compare = 0;
      if (compareAt > resolved) compare = compareAt;
      else if (open && resolved < base && base > 0) compare = base;
      if (compare > resolved && resolved >= 0) {
        return (
          '<div class="wcf-variant-card__prices wcf-variant-card__prices--discount">' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--compare">' +
          '<s>' +
          escapeHtml(formatMoney(compare)) +
          '</s></span>' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--sale">' +
          escapeHtml(formatMoney(resolved)) +
          '</span></div>'
        );
      }
      return (
        '<div class="wcf-variant-card__prices">' +
        '<span class="wcf-variant-card__price wcf-variant-card__price--current">' +
        escapeHtml(formatMoney(resolved)) +
        '</span></div>'
      );
    }

    function capacityRingModel(slot) {
      if (!slot || slotHidden(slot)) return null;
      var raw = slot._raw || {};
      var rem = Number(
        raw.capacity_remaining != null && raw.capacity_remaining !== ''
          ? raw.capacity_remaining
          : slot.capacity_remaining
      );
      var tot = Number(
        raw.capacity_total != null && raw.capacity_total !== '' ? raw.capacity_total : slot.capacity_total
      );
      if (slotSoldOut(slot)) {
        return {
          rem: 0,
          tot: tot > 0 && Number.isFinite(tot) ? tot : 1,
          used: tot > 0 && Number.isFinite(tot) ? tot : 1,
          pctUsed: 100,
          pctRem: 0,
          soldOut: true,
        };
      }
      if (!(tot > 0) || !Number.isFinite(rem) || rem < 0) return null;
      var used = Math.max(0, Math.min(tot, tot - rem));
      var pctUsed = (used / tot) * 100;
      pctUsed = Math.max(0, Math.min(100, pctUsed));
      var pctRem = (rem / tot) * 100;
      pctRem = Math.max(0, Math.min(100, pctRem));
      return { rem: rem, tot: tot, used: used, pctUsed: pctUsed, pctRem: pctRem };
    }

    /** Tier by occupancy (booked %): empty event = green, nearly full = red. */
    function capacityRingTier(pctUsed) {
      var pct = Math.round(pctUsed);
      if (pct >= 100) return 'soldout';
      if (pct >= 66) return 'low';
      if (pct >= 33) return 'medium';
      return 'high';
    }

    function capacityRingAriaLabel(m) {
      if (!m || !(m.tot > 0)) return 'Capacity — select a time to see availability';
      if (m.soldOut || m.rem <= 0) return 'Capacity — sold out';
      return (
        Math.round(m.used) +
        ' of ' +
        Math.round(m.tot) +
        ' spots booked, ' +
        (Math.round(m.pctUsed * 10) / 10) +
        ' percent full'
      );
    }

    function capacityRingPctText(m) {
      if (!m) return '';
      if (m.soldOut || m.rem <= 0) return '';
      if (m.used <= 0) return '0%';
      if (m.used >= m.tot) return '100%';
      var tenths = Math.round(m.pctUsed * 10) / 10;
      return (tenths % 1 === 0 ? String(Math.round(tenths)) : tenths.toFixed(1)) + '%';
    }

    function syncCapacityRingEmpty(ring) {
      ring.hidden = false;
      ring.classList.add('is-empty');
      ring.setAttribute('data-capacity-tier', 'empty');
      ring.setAttribute('aria-label', 'Capacity — select a time to see availability');
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = '—';
      if (pct) pct.textContent = '';
      if (prog) {
        prog.style.strokeDasharray = '';
        prog.style.strokeDashoffset = '';
        prog.style.stroke = '';
      }
    }

    function applyCapacityRingProgress(prog, m) {
      var tot = Math.round(m.tot);
      var used = Math.round(m.used);
      if (tot < 1) tot = 1;
      if (used < 0) used = 0;
      if (used > tot) used = tot;

      /* Ring fill = booked (empty → 0%, sold out → solid). Segmented when tot ≤ 40. */
      if (used <= 0) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '100';
        return;
      }

      if (used >= tot) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '0';
        return;
      }

      if (tot <= 40) {
        var segLen = 100 / tot;
        var gap = Math.min(0.55, segLen * 0.14);
        var draw = Math.max(0.08, segLen - gap);
        var parts = [];
        var empty = Math.max(0, tot - used);
        var i;
        for (i = 0; i < tot; i++) {
          if (i < used) {
            parts.push(draw.toFixed(3), gap.toFixed(3));
          } else {
            parts.push('0', segLen.toFixed(3));
          }
        }
        prog.style.strokeDasharray = parts.join(' ');
        prog.style.strokeDashoffset = '0';
        return;
      }

      var pctExact = (used / tot) * 100;
      pctExact = Math.max(0, Math.min(100, pctExact));
      prog.style.strokeDasharray = '100 100';
      if (pctExact >= 100) {
        prog.style.strokeDashoffset = '0';
      } else if (pctExact <= 0) {
        prog.style.strokeDashoffset = '100';
      } else {
        prog.style.strokeDashoffset = String(pctExact - 100);
      }
    }

    function capacityRingEnabled() {
      var attr = wizardRoot.getAttribute('data-wbw-show-capacity-ring');
      return attr !== 'false';
    }

    function syncCapacityRing() {
      if (!capacityRingEnabled()) return;
      var ring = wizardRoot.querySelector('[data-wbw-capacity-ring]');
      if (!ring) return;
      if (state.branch !== 'datetime') {
        ring.hidden = true;
        return;
      }
      ring.hidden = false;
      var m = capacityRingModel(state.selectedSlot);
      if (!m) {
        syncCapacityRingEmpty(ring);
        return;
      }
      var tier = capacityRingTier(m.pctUsed);
      ring.classList.remove('is-empty');
      ring.setAttribute('data-capacity-tier', tier);
      ring.setAttribute('aria-label', capacityRingAriaLabel(m));
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = m.soldOut || m.rem <= 0 ? 'Sold out' : Math.round(m.used) + '/' + Math.round(m.tot);
      if (pct) pct.textContent = capacityRingPctText(m);
      if (prog) applyCapacityRingProgress(prog, m);
    }

    function updateSelectionSummary() {
      var wrap = wizardRoot.querySelector('[data-wbw-selection-summary-wrapper]');
      var sum = wizardRoot.querySelector('[data-wbw-selection-summary]');
      if (!wrap || !sum) return;
      var lines = [];
      var slot = state.selectedSlot;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = findWizardVariant(k);
        if (!v) return;
        var label = String(v.label || v.title || 'Workshop').trim();
        var lineSlot = resolveVariantSlot(k) || slot;
        var unit = resolveVariantPriceCents(v, lineSlot);
        var lt = unit * q;
        var whenTxt = lightboxPickWhenText(k);
        var img = v.image_url
          ? '<img class="wbw-sel-line__img" src="' +
            escapeHtml(v.image_url) +
            '" alt="' +
            escapeHtml(label) +
            '" width="72" height="72" loading="lazy">'
          : '<span class="wbw-sel-line__img wbw-sel-line__img--ph" aria-hidden="true"></span>';
        lines.push(
          '<div class="wbw-sel-line">' +
          '<div class="wbw-sel-line__media">' +
          img +
          '</div>' +
          '<div class="wbw-sel-line__info">' +
          '<span class="wbw-sel-line__name">' +
          escapeHtml(label) +
          '</span>' +
          '<span class="wbw-sel-line__qty">Qty ' +
          escapeHtml(String(q)) +
          (whenTxt ? ' · ' + escapeHtml(whenTxt) : '') +
          '</span></div>' +
          '<span class="wbw-sel-line__line-total">' +
          escapeHtml(formatMoney(lt)) +
          '</span></div>'
        );
      });
      sum.innerHTML = lines.join('');
      wrap.hidden = lines.length === 0;
      var mid = wizardRoot.querySelector('.wbw-variants-booking-mid');
      if (mid) mid.classList.toggle('is-empty', lines.length === 0);
      paintSelFollow();
      try {
        document.dispatchEvent(new CustomEvent('wbw:selection-ui', { detail: { rootId: wizardRoot.id || '' } }));
      } catch (_) {}
    }

    function selectedFollowItems() {
      var items = [];
      var activeId = vQtyKey(state.focusedVariantId || '');
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var item = findWizardVariant(k);
        if (!item || item._isAddon) return;
        items.push({
          k: k,
          q: q,
          item: item,
          when: lightboxPickWhenText(k),
          on: k === activeId
        });
      });
      var activeAt = -1;
      items.forEach(function (row, i) {
        if (row.on) activeAt = i;
      });
      if (activeAt >= 0) items.push(items.splice(activeAt, 1)[0]);
      else if (items.length) items[items.length - 1].on = true;
      return items;
    }

    function selFollowEl() {
      var el = document.querySelector('[data-wbw-sel-follow]');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'wbw-sel-follow wbw-lb__picks wbw-lb__picks--stack';
      el.setAttribute('data-wbw-sel-follow', '');
      el.hidden = true;
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        var clearBtn = e.target.closest('[data-wbw-action="clear-selection"]');
        if (clearBtn) {
          e.preventDefault();
          state.variantQty = {};
          renderVariants();
          return;
        }
        var pick = e.target.closest('[data-wbw-sel-follow-pick]');
        if (pick && el.classList.contains('is-open')) {
          var pid = String(pick.getAttribute('data-wbw-sel-follow-pick') || '');
          if (pid) {
            state.focusedVariantId = pid;
            previewWizardVariant(pid, { syncPdp: false, scrollCarousel: true });
            updateVariantStepUi();
          }
          return;
        }
        if (e.target.closest('[data-wbw-sel-follow-toggle]')) {
          el.classList.toggle('is-open');
        }
      });
      if (!document.__wbwSelFollowDoc) {
        document.__wbwSelFollowDoc = true;
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-wbw-sel-follow]')) return;
          var follow = document.querySelector('[data-wbw-sel-follow]');
          if (follow) follow.classList.remove('is-open');
        });
      }
      if (!state._wbwSelFollowBranch && window.MutationObserver) {
        state._wbwSelFollowBranch = true;
        new MutationObserver(function () {
          paintSelFollow();
        }).observe(wizardRoot, { attributes: true, attributeFilter: ['data-wbw-branch'] });
      }
      return el;
    }

    function selFollowListInView() {
      var slot = wizardRoot.querySelector('[data-wbw-selection-slot]');
      if (!slot || slot.classList.contains('is-empty') || slot.hidden) return false;
      var rect = slot.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      return rect.top < vh - 48 && rect.bottom > 80;
    }

    function syncSelFollowDock(el) {
      if (!el) return;
      var inView = selFollowListInView();
      el.classList.toggle('is-docked', inView);
      if (inView) el.classList.remove('is-open');
    }

    function bindSelFollowObserver() {
      if (state._wbwSelFollowIo || !window.IntersectionObserver) return;
      var slot = wizardRoot.querySelector('[data-wbw-selection-slot]');
      if (!slot) return;
      state._wbwSelFollowIo = new IntersectionObserver(
        function () {
          syncSelFollowDock(document.querySelector('[data-wbw-sel-follow]'));
        },
        { threshold: [0, 0.18, 0.4], rootMargin: '0px 0px -6% 0px' }
      );
      state._wbwSelFollowIo.observe(slot);
      if (!state._wbwSelFollowResize) {
        state._wbwSelFollowResize = true;
        window.addEventListener(
          'resize',
          function () {
            paintSelFollow();
          },
          { passive: true }
        );
      }
    }

    function paintSelFollow() {
      var el = selFollowEl();
      var items = selectedFollowItems();
      var onVariants = wizardRoot.getAttribute('data-wbw-branch') === 'variants';
      var lbOpen = !!document.querySelector('[data-wbw-lightbox]');
      if (!isMobileViewport() || !onVariants || !items.length || lbOpen) {
        el.hidden = true;
        el.classList.remove('is-open');
        return;
      }
      el.hidden = false;
      bindSelFollowObserver();
      syncSelFollowDock(el);
      var peekStart = Math.max(0, items.length - 3);
      var sig = items
        .map(function (row) {
          return row.k + ':' + row.q + ':' + (row.when || '') + ':' + (row.on ? '1' : '0');
        })
        .join('|') +
        ':' +
        String(computeTotalCents());
      el.style.setProperty('--wbw-n', String(items.length));
      el.style.setProperty('--wbw-peek-step', '0.95rem');
      el.style.setProperty('--wbw-rest', Math.min(2, items.length - 1) * 0.95 + 'rem');
      if (el.getAttribute('data-wbw-follow-sig') === sig) return;
      el.setAttribute('data-wbw-follow-sig', sig);
      el.innerHTML =
        '<div class="wbw-lb__stack" data-wbw-sel-follow-toggle data-count="' +
        Math.min(3, items.length) +
        '">' +
        items
          .map(function (row, i) {
            var peek = i < peekStart ? -1 : i - peekStart;
            return (
              '<button type="button" class="wbw-lb__pick wbw-lb__stack-card' +
              (row.on ? ' is-active' : '') +
              (peek < 0 ? ' is-back' : '') +
              '" data-wbw-sel-follow-pick="' +
              escapeHtml(row.k) +
              '" style="--wbw-stack-i:' +
              i +
              ';--wbw-peek:' +
              peek +
              '">' +
              lightboxPickInnerHtml(row) +
              '</button>'
            );
          })
          .join('') +
        '</div>' +
        '<div class="wbw-lb__picks-foot">' +
        '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-wbw-action="clear-selection">Clear</button>' +
        '<span class="wbw-lb__total">Total <strong>' +
        escapeHtml(formatMoney(computeTotalCents())) +
        '</strong></span></div>';
    }

    function toolbarFocusId() {
      if (state.focusedVariantId && findWizardVariant(state.focusedVariantId)) {
        return state.focusedVariantId;
      }
      var first = wizardRoot.querySelector('[data-wbw-variants] .wcf-variant-row');
      return first ? String(first.getAttribute('data-variant-id') || '') : '';
    }

    function bindToolbarQty(host, id) {
      if (!host) return;
      function go(delta, e) {
        e.preventDefault();
        e.stopPropagation();
        var popupPre =
          state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
        if (!slotBookable(state.selectedSlot) && !popupPre) return;
        adjustVariantQty(id, delta);
      }
      var inc = host.querySelector('[data-wbw-qty-inc]');
      var dec = host.querySelector('[data-wbw-qty-dec]');
      if (inc) inc.addEventListener('click', function (e) { go(1, e); });
      if (dec) dec.addEventListener('click', function (e) { go(-1, e); });
    }

    function syncVariantToolbar() {
      var bar = wizardRoot.querySelector('[data-wbw-variant-toolbar]');
      if (!bar) return;
      var id = toolbarFocusId();
      var qtyHost = bar.querySelector('[data-wbw-toolbar-qty]');
      var v = findWizardVariant(id);
      if (!v) {
        if (qtyHost) qtyHost.innerHTML = '';
        return;
      }
      if (!state.focusedVariantId) state.focusedVariantId = id;
      var qty = state.variantQty[id] || 0;
      if (qtyHost) {
        qtyHost.innerHTML = variantQtyControlHtml(id, qty);
        bindToolbarQty(qtyHost, id);
      }
    }

    function bindToolbarCarouselFocus(wrap) {
      if (!wrap || wrap.__wbwToolbarFocus) return;
      wrap.__wbwToolbarFocus = true;
      var t = null;
      wrap.addEventListener(
        'scroll',
        function () {
          if (t) window.clearTimeout(t);
          t = window.setTimeout(function () {
            var rows = wrap.querySelectorAll('.wcf-variant-row');
            var left = getCarouselOffset(wrap);
            var best = null;
            var bestDist = Infinity;
            for (var i = 0; i < rows.length; i++) {
              var dist = Math.abs(carouselSlideScrollLeft(wrap, rows[i]) - left);
              if (dist < bestDist) {
                bestDist = dist;
                best = rows[i];
              }
            }
            if (!best) return;
            var id = String(best.getAttribute('data-variant-id') || '');
            if (id && id !== state.focusedVariantId) {
              state.focusedVariantId = id;
              syncVariantToolbar();
            }
          }, 80);
        },
        { passive: true }
      );
    }

    function renderVariants() {
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      var slot = state.selectedSlot;
      var popupPreSlot =
        !slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
      var eventOpen = slotBookable(slot) || popupPreSlot;
      var list = variants.slice();
      var addonV = addonVariantObject();
      if (addonV) list.push(addonV);

      if (!list.length) {
        wrap.innerHTML =
          '<div class="wcf-variants-empty"><p class="wcf-variants-empty__text">No workshop styles found for this product.</p></div>';
        updateVariantStepUi();
        return;
      }

      var mount = wrap;
      if (isMobileViewport()) {
        mount = prepareVariantCarouselMount(wrap, list.length);
      } else {
        wrap.innerHTML = '';
      }

      list.forEach(function (v, idx) {
        var id = vQtyKey(v.id);
        var qty = state.variantQty[id] || 0;
        var isAddon = !!v._isAddon;
        var row = document.createElement('div');
        row.className =
          'wcf-variant-row wbw-variant-row--wizard' +
          (qty > 0 ? ' is-active' : '') +
          (isAddon ? ' wbw-variant-row--addon' : '');
        row.setAttribute('data-variant-id', id);
        if (isAddon) row.setAttribute('data-wbw-addon-variant', 'true');

        var label = v.label || v.title || 'Workshop';
        var card = document.createElement('div');
        card.className = 'wcf-variant-card';
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', label);
        if (!eventOpen) {
          /* Store calendar path without a slot: visual only. Popup keeps controls usable. */
          if (!(state.selectedVenue && !isStoreVenue(state.selectedVenue))) {
            row.classList.add('is-disabled');
          }
        }
        var imgUrl = v.image_url || '';
        var eager = idx < 3;
        var imgInner = imgUrl
          ? '<img class="wcf-variant-card__img" src="' +
            escapeHtml(imgUrl) +
            '" alt="' +
            escapeHtml(label) +
            '" width="720" height="720" decoding="async"' +
            (eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') +
            '>'
          : '<div class="wcf-variant-card__img wcf-variant-card__img--placeholder" aria-hidden="true"></div>';
        card.innerHTML =
          '<div class="wcf-variant-card__media">' +
          imgInner +
          (isAddon
            ? ''
            : '<button type="button" class="wbw-variant-zoom" data-wbw-zoom aria-label="View larger">⤢</button>') +
          '</div>' +
          '<div class="wbw-variant-card__meta">' +
          '<div class="wcf-variant-card__title">' +
          escapeHtml(label) +
          '</div>' +
          formatWizardVariantPricesOuter(v, resolveVariantSlot(id) || state.selectedSlot) +
          '</div>';

        var zoomBtn = card.querySelector('[data-wbw-zoom]');
        if (zoomBtn) {
          zoomBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (state._wbwIgnoreZoomUntil && Date.now() < state._wbwIgnoreZoomUntil) return;
            openWizardVariantImageZoom(id);
          });
        }

        function bindMobileVariantCardOpen(cardEl, variantId, isAddonRow) {
          if (!isMobileViewport() || isAddonRow) return;
          var startX = 0;
          var startY = 0;
          var active = false;
          var moved = false;
          var touchId = null;
          cardEl.addEventListener(
            'touchstart',
            function (e) {
              if (e.touches.length !== 1) return;
              if (e.target.closest('[data-wbw-zoom], [data-wbw-variant-qty], .wbw-stepper, .wcf-qty--variant')) return;
              var t = e.touches[0];
              active = true;
              moved = false;
              touchId = t.identifier;
              startX = t.clientX;
              startY = t.clientY;
            },
            { passive: true }
          );
          cardEl.addEventListener(
            'touchmove',
            function (e) {
              if (!active || touchId == null) return;
              for (var i = 0; i < e.touches.length; i++) {
                if (e.touches[i].identifier !== touchId) continue;
                if (
                  Math.abs(e.touches[i].clientX - startX) > 10 ||
                  Math.abs(e.touches[i].clientY - startY) > 10
                ) {
                  moved = true;
                }
                break;
              }
            },
            { passive: true }
          );
          function endTouch(e) {
            if (!active) return;
            var ended = false;
            for (var i = 0; i < e.changedTouches.length; i++) {
              if (e.changedTouches[i].identifier === touchId) {
                ended = true;
                break;
              }
            }
            if (!ended) return;
            active = false;
            touchId = null;
            var wrap = cardEl.closest('[data-wbw-variants]');
            if (wrap && wrap.__wbwSwipeEndAt && Date.now() - wrap.__wbwSwipeEndAt < 450) return;
            if (moved) return;
            if (state._wbwIgnoreZoomUntil && Date.now() < state._wbwIgnoreZoomUntil) return;
            openWizardVariantImageZoom(variantId);
          }
          cardEl.addEventListener('touchend', endTouch, { passive: true });
          cardEl.addEventListener('touchcancel', function () {
            active = false;
            touchId = null;
          }, { passive: true });
        }

        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-wbw-zoom], [data-wbw-variant-qty]')) return;
          if (state._wbwIgnoreZoomUntil && Date.now() < state._wbwIgnoreZoomUntil) return;
          if (isMobileViewport()) return;
          if (!isAddon) previewWizardVariant(id);
          var popupPre =
            state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
          if (!slotBookable(state.selectedSlot) && !popupPre) return;
          if (!(state.variantQty[id] > 0)) adjustVariantQty(id, 1);
        });
        bindMobileVariantCardOpen(card, id, isAddon);

        var buy = document.createElement('div');
        buy.className = 'wbw-variant-buy-row';
        if (qty <= 0) buy.hidden = true;
        buy.innerHTML = variantQtyControlHtml(id, qty);
        bindToolbarQty(buy, id);

        row.appendChild(card);
        row.appendChild(buy);
        mount.appendChild(row);
      });

      /* Warm CDN cache for remaining slides so swipes feel instant. */
      list.forEach(function (v, idx) {
        if (idx < 3 || !v.image_url) return;
        var warm = new Image();
        warm.decoding = 'async';
        warm.src = v.image_url;
      });

      bindVariantGridResize(wrap, wizardRoot);
      bindToolbarCarouselFocus(wrap);
      if (!state.focusedVariantId) {
        var firstRow = wrap.querySelector('.wcf-variant-row');
        if (firstRow) state.focusedVariantId = firstRow.getAttribute('data-variant-id') || '';
      }
      if (wrap.classList.contains('wcf-variants--carousel') && getCarouselOffset(wrap)) {
        setCarouselOffset(wrap, 0);
      }
      updateVariantStepUi();
      syncVariantToolbar();
    }

    function lightboxVariantList() {
      return variants.filter(function (v) {
        return v && !v._isAddon;
      });
    }

    function closeWizardLightbox() {
      closePrettySelects();
      var box = document.querySelector('[data-wbw-lightbox]');
      if (box) {
        persistLightboxWhen(box, 'close');
        box.remove();
      }
      document.documentElement.classList.remove('wbw-lb-open');
      state.lbAskApply = false;
      updateVariantStepUi();
    }

    function resetWizardAfterSuccessfulAtc() {
      var completedVenue = state.selectedVenue;
      var store = !!(completedVenue && isStoreVenue(completedVenue));
      closePrettySelects();
      var lb = document.querySelector('[data-wbw-lightbox]');
      if (lb) lb.remove();
      document.documentElement.classList.remove('wbw-lb-open');
      state.lbAskApply = false;
      closeWizardZoomOverlay(sectionId || (data && data.sectionId));
      teardownWizardZoomHud();

      /* Clear design qty only — keep venue (+ date/time) so ATC lands back on
         store calendar (datetime) or popup booking (variants), not venue step 1. */
      state.variantQty = {};
      state.variantWhen = {};
      state.focusedVariantId = state.lockedVariantId ? vQtyKey(state.lockedVariantId) : '';
      state.lbEditVariant = '';
      state.lbApplyAll = null;
      state.lbAskApply = false;
      clearWizardNotice();

      if (completedVenue && typeof S.stashVenueSession === 'function') {
        try {
          S.stashVenueSession(completedVenue);
        } catch (_) {}
      }

      if (store) {
        setBranch('datetime', { track: false });
        if (typeof S.renderCalendar === 'function') {
          S.renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: false });
        }
        if (typeof S.syncDatetimeHasDate === 'function') S.syncDatetimeHasDate();
      } else if (completedVenue) {
        setBranch('variants', { track: false });
        if (typeof S.refreshPopupDatetimeControls === 'function') {
          S.refreshPopupDatetimeControls({
            preferredDate: state.selectedDate || '',
            preferredGid: state.selectedSlot ? slotSyncKey(state.selectedSlot) : '',
            apply: !!state.selectedDate,
          });
        }
      } else {
        if (typeof clearVenueSelection === 'function') {
          clearVenueSelection({ preserveUrl: true, preserveVenueLabel: false });
        }
        setBranch('venue', { track: false });
      }

      renderVariants();
      updateVariantStepUi();
      paintSelFollow();
      syncCapacityRing();
    }

    function isPopupBooking() {
      return !!(state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking');
    }

    function slotSyncKey(slot) {
      if (!slot) return '';
      var id = String(slot.gid || slot.canonical_event_id || '').trim();
      if (id) return id;
      var dk = toIsoDateKey(slotDateKey(slot)) || String(slotDateKey(slot) || '').slice(0, 10);
      var tl = String(slot.time_label || '').trim();
      return dk && tl ? dk + '|' + tl : '';
    }

    function findSlotBySyncKey(gid) {
      var want = String(gid || '').trim();
      if (!want) return null;
      var list = state.slotList || [];
      for (var i = 0; i < list.length; i++) {
        if (slotSyncKey(list[i]) === want) return list[i];
      }
      return null;
    }

    /** Owned lightbox stamp wins; otherwise the shared date/time. */
    function resolveVariantSlot(id) {
      var saved = state.variantWhen[vQtyKey(id)];
      if (saved && saved.gid) {
        var s = findSlotForTimeValue(saved.gid);
        if (s && slotBookable(s)) return s;
        return null;
      }
      return state.selectedSlot;
    }

    function currentWhenDate() {
      var mainDate = popupDateSelect();
      return (
        toIsoDateKey(mainDate && mainDate.value) ||
        toIsoDateKey(state.selectedDate) ||
        toIsoDateKey(state.selectedSlot && slotDateKey(state.selectedSlot)) ||
        ''
      );
    }

    function currentWhenGid() {
      var mainTime = popupTimeSelect();
      return String(
        (mainTime && mainTime.value) ||
          (state.selectedSlot && slotSyncKey(state.selectedSlot)) ||
          ''
      ).trim();
    }

    function popupDateKeysFromSelect() {
      var main = popupDateSelect();
      var out = [];
      if (!main) return out;
      for (var i = 0; i < main.options.length; i++) {
        var v = toIsoDateKey(main.options[i].value);
        if (v && out.indexOf(v) < 0) out.push(v);
      }
      return out;
    }

    function fillLightboxTimeSelect(timeSel, dateKey, preferredGid) {
      if (!timeSel) return;
      timeSel.disabled = false;
      timeSel.innerHTML = '<option value="">Select a time</option>';
      var want = toIsoDateKey(dateKey) || String(dateKey || '').trim();
      if (!want) {
        timeSel.value = '';
        syncPrettySelect(timeSel);
        return;
      }
      var daySlots = slotsForDate(want).filter(function (s) {
        return s && !slotHidden(s);
      });
      var keep = String(preferredGid || '').trim();
      if (!daySlots.length) {
        var mainTime = popupTimeSelect();
        var mainDate = popupDateSelect();
        if (
          mainTime &&
          mainTime.options.length > 1 &&
          toIsoDateKey(mainDate && mainDate.value) === want
        ) {
          timeSel.innerHTML = mainTime.innerHTML;
          if (keep) timeSel.value = keep;
          if (!timeSel.value && mainTime.value) timeSel.value = mainTime.value;
          syncPrettySelect(timeSel);
          return;
        }
      }
      daySlots.forEach(function (slot) {
        var key = slotSyncKey(slot);
        if (!key) return;
        var opt = document.createElement('option');
        opt.value = key;
        opt.textContent = formatSlotOptionText(slot);
        opt.disabled = !slotBookable(slot);
        timeSel.appendChild(opt);
      });
      if (keep && daySlots.some(function (s) { return slotSyncKey(s) === keep; })) {
        timeSel.value = keep;
      } else {
        timeSel.value = '';
      }
      syncPrettySelect(timeSel);
    }

    function lightboxVariantId(box) {
      return vQtyKey(box && box.getAttribute('data-wbw-lb-id'));
    }

    function lightboxWhenFor(id) {
      var saved = state.variantWhen[vQtyKey(id)];
      if (saved && (saved.dateKey || saved.gid)) {
        return { dateKey: saved.dateKey || '', gid: saved.gid || '', owned: true };
      }
      return { dateKey: currentWhenDate(), gid: currentWhenGid(), owned: false };
    }

    function stampVariantWhen(id, dateKey, gid) {
      id = vQtyKey(id);
      if (!id) return;
      dateKey = toIsoDateKey(dateKey) || String(dateKey || '').trim();
      gid = String(gid || '').trim();
      if (!dateKey && !gid) delete state.variantWhen[id];
      else state.variantWhen[id] = { dateKey: dateKey, gid: gid };
    }

    function writeSharedWhen(dateKey, gid) {
      dateKey = toIsoDateKey(dateKey) || String(dateKey || '').trim();
      gid = String(gid || '').trim();
      state.selectedDate = dateKey;
      var slot = gid ? findSlotForTimeValue(gid) : null;
      state.selectedSlot = slot && slotBookable(slot) ? slot : null;
      if (liveFlags.syncingWhen) return;
      liveFlags.syncingWhen = true;
      try {
        if (typeof S.refreshPopupDatetimeControls === 'function') {
          S.refreshPopupDatetimeControls({
            preferredMonth: dateKey ? String(dateKey).slice(0, 7) : '',
            preferredDate: dateKey,
            preferredGid: gid,
            apply: false,
          });
        }
      } finally {
        liveFlags.syncingWhen = false;
      }
    }

    function isLbEditingOne(box) {
      if (isMobileViewport()) return true;
      return state.lbApplyAll === false;
    }

    function shouldAskLbApplyAll() {
      return !isMobileViewport() && isPopupBooking() && selectedDesignIds().length >= 2;
    }

    function lightboxHasDateTime(box) {
      if (!box) return false;
      var dateSel = box.querySelector('[data-wbw-lb-date]');
      var timeSel = box.querySelector('[data-wbw-lb-time]');
      return !!(
        dateSel &&
        String(dateSel.value || '').trim() &&
        timeSel &&
        String(timeSel.value || '').trim()
      );
    }

    function syncLbApplyAsk(box) {
      var ask = box && box.querySelector('[data-wbw-lb-apply]');
      if (!ask) return;
      ask.hidden = !(
        shouldAskLbApplyAll() &&
        state.lbApplyAll == null &&
        state.lbAskApply &&
        lightboxHasDateTime(box)
      );
    }

    function stampFocusedVariantWhenFromMain() {
      if (state.lbApplyAll === true) return;
      var id = vQtyKey(state.lbEditVariant || state.focusedVariantId || state.lockedVariantId);
      if (!id) return;
      stampVariantWhen(id, currentWhenDate(), currentWhenGid());
    }

    function refreshOpenLightboxWhen() {
      var box = document.querySelector('[data-wbw-lightbox]');
      if (!box) return;
      fillLightboxWhen(box);
      paintWizardLightbox(box);
    }

    function persistLightboxWhen(box, reason) {
      var id = lightboxVariantId(box);
      if (!id) return;
      var dateSel = box.querySelector('[data-wbw-lb-date]');
      var timeSel = box.querySelector('[data-wbw-lb-time]');
      var dateKey = dateSel ? toIsoDateKey(dateSel.value) || String(dateSel.value || '').trim() : '';
      var gid = timeSel ? String(timeSel.value || '').trim() : '';
      var waiting = shouldAskLbApplyAll() && state.lbApplyAll == null;
      if (waiting && reason === 'change') {
        updateVariantStepUi();
        return;
      }
      if (waiting && reason === 'close') {
        // Undecided apply-to-all on an incidental close (Escape/backdrop/nav):
        // never silently stamp an unconfirmed slot onto every design. Keep only
        // the design being edited; the ask re-appears on the next open.
        if (gid) stampVariantWhen(id, dateKey, gid);
        state.lbAskApply = false;
        updateVariantStepUi();
        return;
      }
      if (isLbEditingOne(box)) {
        stampVariantWhen(id, dateKey, gid);
      } else if (reason === 'change' || state.lbApplyAll === true || (gid && !waiting)) {
        if (dateKey || gid || !(state.selectedSlot || state.selectedDate)) {
          writeSharedWhen(dateKey, gid);
          state.variantWhen = {};
        }
      } else if (!state.selectedSlot && gid) {
        writeSharedWhen(dateKey, gid);
      }
      updateVariantStepUi();
    }

    function lightboxSlot(box) {
      var timeSel = box && box.querySelector('[data-wbw-lb-time]');
      var gid = timeSel ? String(timeSel.value || '').trim() : '';
      if (!gid) {
        var saved = state.variantWhen[lightboxVariantId(box)];
        gid = saved && saved.gid ? String(saved.gid) : '';
      }
      var slot = gid ? findSlotForTimeValue(gid) : null;
      return slot && slotBookable(slot) ? slot : null;
    }

    function fillLightboxWhen(box) {
      var whenEl = box.querySelector('.wbw-lb__when');
      if (whenEl) whenEl.hidden = !isPopupBooking();
      var dateSel = box.querySelector('[data-wbw-lb-date]');
      var timeSel = box.querySelector('[data-wbw-lb-time]');
      if (!dateSel || !timeSel) return;
      dateSel.disabled = false;
      timeSel.disabled = false;
      var keys = uniquePopupDateKeys();
      var seed = lightboxWhenFor(lightboxVariantId(box));
      var liveDate = String(dateSel.value || '').trim();
      var liveGid = String(timeSel.value || '').trim();
      if (state.lbApplyAll == null && liveDate) {
        seed = { dateKey: liveDate, gid: liveGid, owned: true };
      }
      fillDateSelectOptions(dateSel, keys, seed.dateKey);
      fillLightboxTimeSelect(timeSel, dateSel.value, seed.owned ? seed.gid : dateSel.value ? seed.gid : '');
      enhancePopupSelect(dateSel);
      enhancePopupSelect(timeSel);
      syncPrettySelect(dateSel);
      syncPrettySelect(timeSel);
    }

    function applyLightboxWhen(box) {
      persistLightboxWhen(box);
      paintWizardLightbox(box);
    }

    function lightboxPickWhenText(id) {
      var slot = resolveVariantSlot(id);
      var dateTxt = '';
      var timeTxt = '';
      if (slot) {
        var dk = toIsoDateKey(slotDateKey(slot)) || '';
        dateTxt = dk ? formatPopupDateLabel(dk) : '';
        timeTxt = formatSlotOptionText(slot);
      } else {
        var saved = state.variantWhen[vQtyKey(id)];
        if (saved) {
          dateTxt = saved.dateKey ? formatPopupDateLabel(saved.dateKey) : '';
          var savedSlot = saved.gid ? findSlotBySyncKey(saved.gid) : null;
          timeTxt = savedSlot ? formatSlotOptionText(savedSlot) : '';
        }
      }
      if (dateTxt && timeTxt) return dateTxt + ' · ' + timeTxt;
      return dateTxt || timeTxt || '';
    }

    function lightboxPickInnerHtml(row) {
      var img = row.item.image_url
        ? '<img src="' +
          escapeHtml(row.item.image_url) +
          '" alt="' +
          escapeHtml(row.item.label || row.item.title || 'Workshop') +
          '">'
        : '<span class="wbw-lb__pick-ph" aria-hidden="true"></span>';
      return (
        '<span class="wbw-lb__pick-media">' +
        img +
        '</span>' +
        '<span class="wbw-lb__pick-info">' +
        '<span class="wbw-lb__pick-name">' +
        escapeHtml(row.item.label || row.item.title || 'Workshop') +
        '</span>' +
        '<span class="wbw-lb__pick-when' +
        (row.when ? '' : ' is-muted') +
        '">' +
        escapeHtml(row.when || 'Date & time not selected') +
        '</span></span>' +
        '<span class="wbw-lb__pick-qty">Qty ' +
        escapeHtml(String(row.q)) +
        '</span>'
      );
    }

    function paintLightboxPicks(box) {
      var host = box && box.querySelector('[data-wbw-lb-picks]');
      if (!host) return;
      var activeId = lightboxVariantId(box);
      var items = [];
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var item = findWizardVariant(k);
        if (!item || item._isAddon) return;
        items.push({
          k: k,
          q: q,
          item: item,
          when: lightboxPickWhenText(k),
          on: k === activeId
        });
      });
      if (!items.length) {
        host.innerHTML = '';
        host.hidden = true;
        host.classList.remove('is-open', 'wbw-lb__picks--stack');
        host.removeAttribute('data-wbw-picks-sig');
        box._wbwPicksOpen = false;
        return;
      }
      var mobile = isMobileViewport();
      var open = !mobile || !!box._wbwPicksOpen;
      host.hidden = false;
      var rows = items.map(function (row) {
        return (
          '<button type="button" class="wbw-lb__pick' +
          (row.on ? ' is-active' : '') +
          '" data-wbw-lb-pick="' +
          escapeHtml(row.k) +
          '" aria-current="' +
          (row.on ? 'true' : 'false') +
          '">' +
          lightboxPickInnerHtml(row) +
          '</button>'
        );
      });
      var listHtml =
        '<div class="wbw-lb__picks-head"><div class="wbw-lb__picks-label">Selected</div>' +
        (!mobile && state.lbApplyAll === true && rows.length >= 2
          ? '<button type="button" class="wbw-lb__edit-each" data-wbw-lb-edit-each>Edit item</button>'
          : '') +
        '</div>' +
        rows.join('') +
        '<div class="wbw-lb__picks-foot">' +
        '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-wbw-lb-clear>Clear all</button>' +
        '<span class="wbw-lb__total">Total <strong data-wbw-lb-total>' +
        escapeHtml(formatMoney(computeTotalCents())) +
        '</strong></span></div>';
      if (!mobile) {
        host.classList.remove('wbw-lb__picks--stack', 'is-open');
        host.removeAttribute('data-wbw-picks-sig');
        host.innerHTML = listHtml;
        return;
      }
      var stackItems = items.slice();
      var activeAt = -1;
      stackItems.forEach(function (row, i) {
        if (row.on) activeAt = i;
      });
      if (activeAt >= 0) {
        stackItems.push(stackItems.splice(activeAt, 1)[0]);
      }
      var peekStart = Math.max(0, stackItems.length - 3);
      var sig = stackItems
        .map(function (row) {
          return row.k + ':' + row.q + ':' + (row.when || '') + ':' + (row.on ? '1' : '0');
        })
        .join('|');
      var wasOpen = host.classList.contains('is-open');
      host.classList.add('wbw-lb__picks--stack');
      host.style.setProperty('--wbw-n', String(stackItems.length));
      host.style.setProperty('--wbw-peek-step', '0.95rem');
      host.style.setProperty('--wbw-rest', Math.min(2, stackItems.length - 1) * 0.95 + 'rem');
      if (host.getAttribute('data-wbw-picks-sig') !== sig) {
        host.setAttribute('data-wbw-picks-sig', sig);
        host.innerHTML =
          '<div class="wbw-lb__stack" data-wbw-lb-stack data-count="' +
          Math.min(3, stackItems.length) +
          '" aria-expanded="' +
          (open ? 'true' : 'false') +
          '">' +
          stackItems
            .map(function (row, i) {
              var peek = i < peekStart ? -1 : i - peekStart;
              return (
                '<button type="button" class="wbw-lb__pick wbw-lb__stack-card' +
                (row.on ? ' is-active' : '') +
                (peek < 0 ? ' is-back' : '') +
                '" data-wbw-lb-pick="' +
                escapeHtml(row.k) +
                '" style="--wbw-stack-i:' +
                i +
                ';--wbw-peek:' +
                peek +
                '" aria-current="' +
                (row.on ? 'true' : 'false') +
                '">' +
                lightboxPickInnerHtml(row) +
                '</button>'
              );
            })
            .join('') +
          '</div>' +
          '<div class="wbw-lb__picks-foot">' +
          '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-wbw-lb-clear>Clear all</button>' +
          '<span class="wbw-lb__total">Total <strong data-wbw-lb-total>' +
          escapeHtml(formatMoney(computeTotalCents())) +
          '</strong></span></div>';
      }
      var stackEl = host.querySelector('[data-wbw-lb-stack]');
      if (stackEl) stackEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !wasOpen) {
        host.classList.remove('is-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            host.classList.add('is-open');
          });
        });
      } else {
        host.classList.toggle('is-open', open);
      }
    }

    function paintWizardLightbox(box) {
      if (!box) return;
      var id = lightboxVariantId(box);
      var v = findWizardVariant(id);
      if (!v) return;
      var slot = lightboxSlot(box);
      var img = box.querySelector('[data-wbw-lb-img]');
      if (img) {
        img.src = v.image_url || '';
        img.alt = v.label || v.title || '';
      }
      var title = box.querySelector('[data-wbw-lb-title]');
      if (title) title.textContent = v.label || v.title || 'Workshop';
      var price = box.querySelector('[data-wbw-lb-price]');
      if (price) price.innerHTML = formatWizardVariantPricesOuter(v, slot);
      var qtyEl = box.querySelector('[data-wbw-lb-qty]');
      if (qtyEl) qtyEl.textContent = String(state.variantQty[id] || 0);
      var stepper = box.querySelector('[data-wbw-lb-stepper]');
      if (stepper) stepper.classList.toggle('is-active', (state.variantQty[id] || 0) > 0);
      var addBtn = box.querySelector('[data-wbw-lb-add]');
      if (addBtn) {
        var resolved = slot || resolveVariantSlot(id);
        var canAdd =
          !!(resolved && slotBookable(resolved)) ||
          (hasSelectedVariants() && allSelectedVariantsHaveSlot());
        addBtn.disabled = !canAdd;
      }
      syncAtcReminder();
      syncLbApplyAsk(box);
      syncPrettySelect(box.querySelector('[data-wbw-lb-date]'));
      syncPrettySelect(box.querySelector('[data-wbw-lb-time]'));
      box.querySelectorAll('[data-wbw-lb-thumb]').forEach(function (btn) {
        var on = String(btn.getAttribute('data-wbw-lb-thumb')) === id;
        btn.classList.toggle('is-active', on);
        if (on && btn.scrollIntoView) {
          btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
      paintLightboxPicks(box);
    }

    function openWizardLightbox(variantId) {
      if (state._wbwIgnoreZoomUntil && Date.now() < state._wbwIgnoreZoomUntil) return;
      var list = lightboxVariantList();
      var id = vQtyKey(variantId);
      var idx = -1;
      list.forEach(function (v, i) {
        if (vQtyKey(v.id) === id) idx = i;
      });
      if (idx < 0 && list[0]) {
        id = vQtyKey(list[0].id);
        idx = 0;
      }
      var v = findWizardVariant(id);
      if (!v) return;
      previewWizardVariant(id, { syncPdp: false, scrollCarousel: true });
      closeWizardLightbox();
      teardownWizardZoomHud();
      closeImpulseProductZoom(
        (data && data.sectionId) || wizardRoot.getAttribute('data-section-id') || ''
      );

      var box = document.createElement('div');
      box.className = 'wbw-lb';
      box.setAttribute('data-wbw-lightbox', '');
      box.setAttribute('data-wbw-lb-id', id);
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Workshop design');
      box.innerHTML =
        '<button type="button" class="wbw-lb__close" aria-label="Close">&times;</button>' +
        '<div class="wbw-lb__card">' +
        '<div class="wbw-lb__stage">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--prev" aria-label="Previous">‹</button>' +
        '<img class="wbw-lb__img" data-wbw-lb-img src="' +
        escapeHtml(v.image_url || '') +
        '" alt="' +
        escapeHtml(v.label || v.title || '') +
        '">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--next" aria-label="Next">›</button>' +
        '</div>' +
        '<div class="wbw-lb__dock">' +
        '<div class="wbw-lb__meta">' +
        '<span class="wbw-lb__title" data-wbw-lb-title>' +
        escapeHtml(v.label || v.title || 'Workshop') +
        '</span></div>' +
        '<div class="wbw-lb__mid">' +
        '<div class="wbw-lb__left">' +
        '<div class="wbw-lb__when">' +
        '<label class="wbw-lb__field"><span>Date</span><select data-wbw-lb-date><option value="">Select a date</option></select></label>' +
        '<label class="wbw-lb__field"><span>Time</span><select data-wbw-lb-time><option value="">Select a time</option></select></label>' +
        '<div class="wbw-lb__apply" data-wbw-lb-apply hidden>' +
        '<p class="wbw-lb__apply-q">Apply to all selected designs?</p>' +
        '<div class="wbw-lb__apply-btns">' +
        '<button type="button" class="wbw-lb__apply-btn" data-wbw-lb-apply-all>Yes</button>' +
        '<button type="button" class="wbw-lb__apply-btn wbw-lb__apply-btn--no" data-wbw-lb-apply-one>No</button>' +
        '</div></div>' +
        '</div>' +
        '<div class="wbw-lb__picks" data-wbw-lb-picks hidden></div>' +
        '</div>' +
        '<div class="wbw-lb__bar">' +
        '<span class="wbw-lb__price" data-wbw-lb-price>' +
        formatWizardVariantPricesOuter(v, state.selectedSlot) +
        '</span>' +
        '<div class="wbw-stepper" data-wbw-lb-stepper>' +
        '<button type="button" class="wbw-stepper__btn" data-wbw-lb-dec aria-label="Decrease">−</button>' +
        '<span class="wbw-stepper__val" data-wbw-lb-qty>' +
        String(state.variantQty[id] || 0) +
        '</span>' +
        '<button type="button" class="wbw-stepper__btn" data-wbw-lb-inc aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="wbw-atc-wrap">' +
        '<p class="wbw-atc-hint" data-wbw-atc-hint hidden></p>' +
        '<button type="button" class="wcf-btn wcf-btn--primary wbw-lb__add" data-wbw-lb-add>Add to cart</button>' +
        '</div></div></div>' +
        '<div class="wbw-lb__thumbs" data-wbw-lb-thumbs>' +
        list
          .map(function (item, i) {
            var tid = vQtyKey(item.id);
            return (
              '<button type="button" class="wbw-lb__thumb' +
              (tid === id ? ' is-active' : '') +
              '" data-wbw-lb-thumb="' +
              escapeHtml(tid) +
              '" data-wbw-lb-thumb-i="' +
              i +
              '" aria-label="' +
              escapeHtml(item.label || item.title || 'Design') +
              '">' +
              (item.image_url
                ? '<img src="' +
                  escapeHtml(item.image_url) +
                  '" alt="' +
                  escapeHtml(item.label || item.title || 'Design') +
                  '">'
                : '<span class="wbw-lb__thumb-ph"></span>') +
              '</button>'
            );
          })
          .join('') +
        '</div></div></div>';

      function showAt(nextIdx, fromPick) {
        if (!list.length) return;
        persistLightboxWhen(box);
        closePrettySelects();
        idx = (nextIdx + list.length) % list.length;
        id = vQtyKey(list[idx].id);
        box.setAttribute('data-wbw-lb-id', id);
        state.focusedVariantId = id;
        if (state.lbApplyAll === false) state.lbEditVariant = id;
        previewWizardVariant(id, { syncPdp: false, scrollCarousel: true });
        fillLightboxWhen(box);
        paintWizardLightbox(box);
      }

      box.querySelector('.wbw-lb__close').addEventListener('click', closeWizardLightbox);
      box.addEventListener('click', function (e) {
        if (e.target === box) closeWizardLightbox();
      });
      box.querySelector('.wbw-lb__nav--prev').addEventListener('click', function () {
        showAt(idx - 1);
      });
      box.querySelector('.wbw-lb__nav--next').addEventListener('click', function () {
        showAt(idx + 1);
      });
      (function bindLightboxSwipe() {
        var stage = box.querySelector('.wbw-lb__stage');
        if (!stage || list.length < 2) return;
        var startX = 0;
        var startY = 0;
        var pid = 0;
        var tracking = false;
        function ignoreTarget(t) {
          return !!(t && t.closest && t.closest('.wbw-lb__close, .wbw-lb__nav, .wbw-pretty-dd, [data-wbw-pretty-dd-portal]'));
        }
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (ignoreTarget(e.target)) return;
          if (document.querySelector('.wbw-pretty-dd.is-open')) return;
          tracking = true;
          pid = e.pointerId;
          startX = e.clientX;
          startY = e.clientY;
        });
        stage.addEventListener(
          'pointermove',
          function (e) {
            if (!tracking || e.pointerId !== pid) return;
            var dx = e.clientX - startX;
            var dy = e.clientY - startY;
            if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) e.preventDefault();
          },
          { passive: false }
        );
        function finish(e) {
          if (!tracking || (e && e.pointerId !== pid)) return;
          tracking = false;
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
          showAt(dx < 0 ? idx + 1 : idx - 1);
        }
        stage.addEventListener('pointerup', finish);
        stage.addEventListener('pointercancel', function () {
          tracking = false;
        });
      })();
      box.querySelector('[data-wbw-lb-inc]').addEventListener('click', function (e) {
        e.preventDefault();
        if (!wizardZoomQtyAllowed()) return;
        persistLightboxWhen(box);
        adjustVariantQty(id, 1);
        paintWizardLightbox(box);
      });
      box.querySelector('[data-wbw-lb-dec]').addEventListener('click', function (e) {
        e.preventDefault();
        if (!wizardZoomQtyAllowed()) return;
        persistLightboxWhen(box);
        adjustVariantQty(id, -1);
        paintWizardLightbox(box);
      });
      box.querySelector('[data-wbw-lb-add]').addEventListener('click', function (e) {
        e.preventDefault();
        addLightboxToCart(box);
      });
      box.addEventListener('click', function (e) {
        var clearAll = e.target.closest('[data-wbw-lb-clear]');
        if (clearAll && box.contains(clearAll)) {
          e.preventDefault();
          e.stopPropagation();
          state.variantQty = {};
          renderVariants();
          paintWizardLightbox(box);
          updateVariantStepUi();
          return;
        }
        var editEach = e.target.closest('[data-wbw-lb-edit-each]');
        if (editEach && box.contains(editEach)) {
          e.preventDefault();
          state.lbApplyAll = false;
          state.lbAskApply = false;
          state.lbEditVariant = lightboxVariantId(box);
          fillLightboxWhen(box);
          paintWizardLightbox(box);
          return;
        }
        if (box._wbwPicksOpen && !e.target.closest('[data-wbw-lb-picks]')) {
          box._wbwPicksOpen = false;
          paintLightboxPicks(box);
        }
        var pick = e.target.closest('[data-wbw-lb-pick]');
        if (pick && box._wbwPicksOpen && box.contains(pick)) {
          var pid = String(pick.getAttribute('data-wbw-lb-pick') || '');
          var i = -1;
          list.forEach(function (item, n) {
            if (vQtyKey(item.id) === pid) i = n;
          });
          if (i >= 0) showAt(i, true);
          return;
        }
        var stackOpen = e.target.closest('[data-wbw-lb-stack]');
        if (stackOpen && box.contains(stackOpen)) {
          e.preventDefault();
          box._wbwPicksOpen = !box._wbwPicksOpen;
          paintLightboxPicks(box);
          return;
        }
        if (!pick || !box.contains(pick)) return;
        var pid = String(pick.getAttribute('data-wbw-lb-pick') || '');
        var i = -1;
        list.forEach(function (item, n) {
          if (vQtyKey(item.id) === pid) i = n;
        });
        if (i >= 0) showAt(i, true);
      });
      box.querySelectorAll('[data-wbw-lb-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showAt(Number(btn.getAttribute('data-wbw-lb-thumb-i')) || 0);
        });
      });
      var lbDate = box.querySelector('[data-wbw-lb-date]');
      var lbTime = box.querySelector('[data-wbw-lb-time]');
      if (lbDate) {
        lbDate.addEventListener('change', function () {
          fillLightboxTimeSelect(lbTime, String(lbDate.value || '').trim(), '');
          syncPrettySelect(lbDate);
          syncPrettySelect(lbTime);
          if (state.lbApplyAll == null) state.lbAskApply = false;
          persistLightboxWhen(box, 'change');
          paintWizardLightbox(box);
          var dk = String(lbDate.value || '').trim();
          if (dk) {
            try {
              var wbwA = global.WorkshopBookingWizardAnalytics;
              if (wbwA && typeof wbwA.trackUser === 'function') {
                wbwA.trackUser('date', 'wbw_date_select', state, wizardRoot, data, {
                  wbw_date: dk,
                  wbw_source: 'lightbox_date',
                  wbw_variant_id: lightboxVariantId(box),
                });
              }
            } catch (_) {}
          }
        });
      }
      if (lbTime) {
        lbTime.addEventListener('change', function () {
          if (shouldAskLbApplyAll() && state.lbApplyAll == null) state.lbAskApply = true;
          syncPrettySelect(lbTime);
          persistLightboxWhen(box, 'change');
          paintWizardLightbox(box);
          var tv = String(lbTime.value || '').trim();
          if (tv) {
            try {
              var wbwT = global.WorkshopBookingWizardAnalytics;
              if (wbwT && typeof wbwT.trackUser === 'function') {
                wbwT.trackUser('time', 'wbw_time_select', state, wizardRoot, data, {
                  wbw_source: 'lightbox_time',
                  wbw_variant_id: lightboxVariantId(box),
                  wbw_event_id: tv,
                });
              }
            } catch (_) {}
          }
        });
      }
      var applyAllBtn = box.querySelector('[data-wbw-lb-apply-all]');
      var applyOneBtn = box.querySelector('[data-wbw-lb-apply-one]');
      if (applyAllBtn) {
        applyAllBtn.addEventListener('click', function (e) {
          e.preventDefault();
          state.lbApplyAll = true;
          state.lbAskApply = false;
          state.lbEditVariant = '';
          persistLightboxWhen(box, 'change');
          paintWizardLightbox(box);
        });
      }
      if (applyOneBtn) {
        applyOneBtn.addEventListener('click', function (e) {
          e.preventDefault();
          state.lbApplyAll = false;
          state.lbAskApply = false;
          state.lbEditVariant = lightboxVariantId(box);
          persistLightboxWhen(box, 'change');
          paintWizardLightbox(box);
        });
      }

      function onKey(e) {
        if (e.key === 'Escape') {
          if (document.querySelector('.wbw-pretty-dd.is-open')) {
            closePrettySelects();
            return;
          }
          closeWizardLightbox();
        }
        if (e.key === 'ArrowLeft') showAt(idx - 1);
        if (e.key === 'ArrowRight') showAt(idx + 1);
      }
      document.addEventListener('keydown', onKey);
      var prevClose = closeWizardLightbox;
      closeWizardLightbox = function () {
        document.removeEventListener('keydown', onKey);
        closeWizardLightbox = prevClose;
        prevClose();
      };

      document.documentElement.classList.add('wbw-lb-open');
      document.body.appendChild(box);
      paintSelFollow();
      state.lbEditVariant = isMobileViewport() || state.lbApplyAll === false ? id : '';
      state.lbAskApply = false;
      fillLightboxWhen(box);
      paintWizardLightbox(box);
      try {
        var wbwLb = global.WorkshopBookingWizardAnalytics;
        var vLabel = String((v && (v.label || v.title)) || '');
        /* track (not trackUser) — open ≠ design select; don't mark had.design */
        if (wbwLb && typeof wbwLb.track === 'function') {
          wbwLb.track('wbw_design_lightbox_open', state, wizardRoot, data, {
            wbw_variant_id: id,
            wbw_variant_title: vLabel,
            wbw_source: 'lightbox',
          });
        }
      } catch (_) {}
    }

    function openWizardVariantImageZoom(variantId) {
      openWizardLightbox(variantId);
    }

    var zoomHudTeardown = null;
    var zoomHudScheduleTimer = null;

    function isZoomLayerVisible(el) {
      if (!el) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      /* Alpine leave keeps display until transition ends — opacity 0 means closing. */
      if (parseFloat(style.opacity) < 0.05) return false;
      return true;
    }

    function resolveVisibleZoomSectionId(preferred) {
      if (preferred && isZoomLayerVisible(document.getElementById('ProductModal-' + preferred))) {
        return preferred;
      }
      var nodes = document.querySelectorAll('[id^="ProductModal-"]');
      for (var i = 0; i < nodes.length; i++) {
        if (!isZoomLayerVisible(nodes[i])) continue;
        return String(nodes[i].id || '').replace(/^ProductModal-/, '');
      }
      return preferred || '';
    }

    function isAlpineZoomOpen(sectionId) {
      if (!sectionId || !window.Alpine) return null;
      var mediaHost = document.getElementById('product-media-' + sectionId);
      if (!mediaHost) return null;
      try {
        var alpine = window.Alpine.$data(mediaHost);
        if (!alpine || typeof alpine.zoomIsOpen === 'undefined') return null;
        return !!alpine.zoomIsOpen;
      } catch (_) {
        return null;
      }
    }

    function isWizardZoomUiOpen(sectionId) {
      if (isZoomLayerVisible(document.querySelector('[data-wbw-image-zoom]'))) return true;
      var alpineOpen = isAlpineZoomOpen(sectionId);
      if (alpineOpen === false) return false;
      if (alpineOpen === true) return true;
      return !!resolveVisibleZoomSectionId(sectionId);
    }

    function teardownWizardZoomHud() {
      if (zoomHudScheduleTimer) {
        window.clearInterval(zoomHudScheduleTimer);
        zoomHudScheduleTimer = null;
      }
      if (zoomHudTeardown) {
        zoomHudTeardown();
        zoomHudTeardown = null;
      }
      document.querySelectorAll('[data-wbw-zoom-hud]').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.wbw-zoom-gallery--with-hud').forEach(function (el) {
        el.classList.remove('wbw-zoom-gallery--with-hud');
      });
    }

    function closeWizardZoomOverlay(sectionId) {
      var sid = resolveVisibleZoomSectionId(sectionId) || sectionId;
      teardownWizardZoomHud();
      if (sid) closeImpulseProductZoom(sid);
      var fallback = document.querySelector('[data-wbw-image-zoom]');
      if (fallback) {
        fallback.remove();
        document.dispatchEvent(new CustomEvent('wbw:image-zoom-closed'));
      }
    }

    function wizardZoomQtyAllowed() {
      var slot = state.selectedSlot;
      var popupPreSlot =
        !slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
      return !!(slotBookable(slot) || popupPreSlot);
    }

    function scheduleWizardZoomHud(variantId, sectionId) {
      teardownWizardZoomHud();
      var tries = 0;
      zoomHudScheduleTimer = window.setInterval(function () {
        tries += 1;
        var sid = resolveVisibleZoomSectionId(sectionId);
        var openSid = sid || sectionId;
        if (isWizardZoomUiOpen(openSid) || document.querySelector('[data-wbw-image-zoom]')) {
          window.clearInterval(zoomHudScheduleTimer);
          zoomHudScheduleTimer = null;
          mountWizardZoomHud(variantId, openSid);
          return;
        }
        if (tries >= 40) {
          window.clearInterval(zoomHudScheduleTimer);
          zoomHudScheduleTimer = null;
        }
      }, 80);
    }

    function mediaIdFromZoomThumbEl(el, sectionId) {
      return parseZoomThumbMediaId(el, sectionId);
    }

    function getActiveZoomMediaId(sectionId) {
      if (!sectionId) return '';
      var thumbsRoot = document.getElementById('x-zoom-thumbnail-' + sectionId);
      var gallery = document.getElementById('media-gallery-' + sectionId);
      var modal = document.getElementById('ProductModal-' + sectionId);
      var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
      var i;

      /* 1) Active zoom slide first — thumb opacity often lags on first media (Candle Holder). */
      var activeSlide =
        (gallery && gallery.querySelector('.splide__slide.is-active, .x-splide-slide.is-active')) ||
        (modal && modal.querySelector('.splide__slide.is-active, .x-splide-slide.is-active'));
      if (activeSlide) {
        var fromSlide = parseZoomSlideMediaId(activeSlide, sectionId);
        if (fromSlide) return fromSlide;
      }

      /* 2) Match active slide image src to a thumb src */
      var activeImg = activeSlide && activeSlide.querySelector('img');
      if (activeImg && thumbs.length) {
        var src = String(activeImg.currentSrc || activeImg.src || '');
        var srcKey = src.split('?')[0].replace(/_\d+x\d*(@2x)?\./, '.');
        for (i = 0; i < thumbs.length; i++) {
          var tImg = thumbs[i].querySelector('img');
          if (!tImg) continue;
          var tSrc = String(tImg.currentSrc || tImg.src || '')
            .split('?')[0]
            .replace(/_\d+x\d*(@2x)?\./, '.');
          if (srcKey && tSrc && (srcKey.indexOf(tSrc) !== -1 || tSrc.indexOf(srcKey) !== -1 || src.indexOf(tSrc) !== -1)) {
            var fromSrc = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
            if (fromSrc) return fromSrc;
          }
        }
      }

      /* 3) Splide index → thumb */
      if (gallery && gallery.splide && Number.isFinite(gallery.splide.index) && thumbs[gallery.splide.index]) {
        var fromIdx = mediaIdFromZoomThumbEl(thumbs[gallery.splide.index], sectionId);
        if (fromIdx) return fromIdx;
      }

      /* 4) Thumb without opacity-30 (last — can stick on first variant) */
      for (i = 0; i < thumbs.length; i++) {
        if (!thumbs[i].classList.contains('opacity-30')) {
          var fromActive = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
          if (fromActive) return fromActive;
        }
      }
      return '';
    }

    function findWizardVariantByLabelText(text) {
      var raw = String(text || '')
        .toLowerCase()
        .replace(/#.*$/, '')
        .trim();
      if (!raw) return null;
      var best = null;
      var bestLen = 0;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        var label = String(variants[i].label || variants[i].title || '')
          .toLowerCase()
          .trim();
        if (!label) continue;
        if (raw === label || raw.indexOf(label) !== -1 || label.indexOf(raw) !== -1) {
          if (label.length > bestLen) {
            bestLen = label.length;
            best = variants[i];
          }
        }
      }
      return best;
    }

    function findWizardVariantByFeaturedMediaId(mediaId, sectionRoot) {
      if (!mediaId) return null;
      mediaId = String(mediaId);
      var styleIdx = data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        ensureVariantMediaMeta(variants[i], sectionRoot, styleIdx);
        if (String(variants[i].featured_media_id || '') === mediaId) return variants[i];
      }
      var list = parseVariantsJson(sectionRoot);
      var optKey = 'option' + (styleIdx + 1);
      for (i = 0; i < list.length; i++) {
        var sv = list[i];
        var fm =
          (sv.featured_media && sv.featured_media.id) ||
          sv.featured_media_id ||
          (sv.featured_image && sv.featured_image.id);
        if (String(fm || '') !== mediaId) continue;
        var styleVal = normalizeOptionValue(sv[optKey] || '');
        var j;
        for (j = 0; j < variants.length; j++) {
          if (isAddonVariantId(variants[j].id)) continue;
          if (String(variants[j].id) === String(sv.id)) return variants[j];
          var wStyle = normalizeOptionValue(
            styleValueFromVariant(variants[j], styleIdx) || variants[j].label || ''
          );
          if (styleVal && wStyle && wStyle === styleVal) return variants[j];
        }
      }
      return null;
    }

    /**
     * Map zoom media → style variant.
     * Prefer image alt ("Moon Lamp") — reliable even with liquid clones / multi-shot runs.
     */
    function findWizardVariantForZoomMedia(mediaId, sectionId, sectionRoot) {
      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      var activeImg =
        modal &&
        modal.querySelector('.splide__slide.is-active img, .x-splide-slide.is-active img');
      var altMatch = findWizardVariantByLabelText(activeImg && activeImg.getAttribute('alt'));
      if (altMatch) return altMatch;

      if (!mediaId) return null;
      mediaId = String(mediaId);
      var exact = findWizardVariantByFeaturedMediaId(mediaId, sectionRoot);
      if (exact) return exact;

      var styleIdx = data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      var featuredToVariant = {};
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        ensureVariantMediaMeta(variants[i], sectionRoot, styleIdx);
        var fid = String(variants[i].featured_media_id || '');
        if (fid) featuredToVariant[fid] = variants[i];
      }

      var thumbsRoot = sectionId ? document.getElementById('x-zoom-thumbnail-' + sectionId) : null;
      var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
      var owner = null;
      for (i = 0; i < thumbs.length; i++) {
        var tid = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
        if (!tid) continue;
        if (featuredToVariant[tid]) owner = featuredToVariant[tid];
        if (tid === mediaId) return owner;
      }
      return null;
    }

    function findWizardZoomMediaEl(sectionId) {
      var fallback = document.querySelector('[data-wbw-image-zoom] .wbw-image-zoom__img');
      if (fallback) return fallback;
      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      if (!modal) return null;
      var activeSlide = modal.querySelector('.splide__slide.is-active img, .x-splide-slide.is-active img');
      if (activeSlide) return activeSlide;
      var candidates = modal.querySelectorAll(
        'img.image-magnify-lightbox, .pswp__img, .zoomImg, [id*="-image-zoom-"] img, .product-media-modal__image img, .media-zoom img, img'
      );
      var best = null;
      var bestArea = 0;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el || !el.getBoundingClientRect) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 80 || r.height < 80) continue;
        if (r.bottom <= 0 || r.top >= window.innerHeight) continue;
        /* Skip thumbnail strip images */
        if (el.closest && el.closest('[id^="x-zoom-thumbnail-"]')) continue;
        var area = r.width * r.height;
        if (area > bestArea) {
          bestArea = area;
          best = el;
        }
      }
      return best;
    }

    function findWizardZoomThumbnailEl(sectionId) {
      if (!sectionId) return null;
      return document.getElementById('x-zoom-thumbnail-' + sectionId);
    }

    function mountHudIntoZoomChrome(hud, sectionId) {
      var thumbs = findWizardZoomThumbnailEl(sectionId);
      if (thumbs && thumbs.parentNode) {
        hud.classList.add('wbw-zoom-hud--docked');
        thumbs.parentNode.insertBefore(hud, thumbs);
        var gallery = document.getElementById('media-gallery-' + sectionId);
        if (gallery) {
          gallery.classList.add('wbw-zoom-gallery--with-hud');
          if (gallery.splide && typeof gallery.splide.refresh === 'function') {
            window.requestAnimationFrame(function () {
              try {
                gallery.splide.refresh();
              } catch (_) {}
              positionZoomGalleryArrows(sectionId);
            });
          } else {
            positionZoomGalleryArrows(sectionId);
          }
        }
        return true;
      }
      document.body.appendChild(hud);
      return false;
    }

    /** Pin <> arrows to the visible photo (object-contain), not the tall gallery box. */
    function positionZoomGalleryArrows(sectionId) {
      var gallery = sectionId ? document.getElementById('media-gallery-' + sectionId) : null;
      if (!gallery || !gallery.classList.contains('wbw-zoom-gallery--with-hud')) return;
      var img = gallery.querySelector(
        '.splide__slide.is-active img, .x-splide-slide.is-active img, .splide__slide img'
      );
      var prev = gallery.querySelector('.splide__arrow--prev');
      var next = gallery.querySelector('.splide__arrow--next');
      if (!img || (!prev && !next)) return;
      var gRect = gallery.getBoundingClientRect();
      if (gRect.height < 40) return;
      var iRect = img.getBoundingClientRect();
      var top = iRect.top;
      var bottom = iRect.bottom;
      var left = iRect.left;
      var right = iRect.right;
      var nw = Number(img.naturalWidth) || 0;
      var nh = Number(img.naturalHeight) || 0;
      if (nw > 0 && nh > 0 && iRect.width > 0 && iRect.height > 0) {
        var er = iRect.width / iRect.height;
        var ir = nw / nh;
        var cw;
        var ch;
        if (er > ir) {
          ch = iRect.height;
          cw = ch * ir;
          left = iRect.left + (iRect.width - cw) / 2;
          right = left + cw;
        } else {
          cw = iRect.width;
          ch = cw / ir;
          top = iRect.top + (iRect.height - ch) / 2;
          bottom = top + ch;
        }
      }
      var midY = (top + bottom) / 2 - gRect.top;
      var inset = 6;
      if (prev) {
        prev.style.top = midY + 'px';
        prev.style.marginTop = '0';
        prev.style.transform = 'translateY(-50%)';
        prev.style.left = Math.max(inset, left - gRect.left + inset) + 'px';
        prev.style.right = 'auto';
      }
      if (next) {
        next.style.top = midY + 'px';
        next.style.marginTop = '0';
        next.style.transform = 'translateY(-50%)';
        next.style.right = Math.max(inset, gRect.right - right + inset) + 'px';
        next.style.left = 'auto';
      }
    }

    function positionWizardZoomHudPanel(hud) {
      if (!hud || hud.classList.contains('wbw-zoom-hud--docked')) return;
      var panel = hud.querySelector('.wbw-zoom-hud__bottom');
      if (!panel) return;
      /* Non-docked fallback only (no thumbnail strip): keep bottom-anchored. */
      panel.style.removeProperty('--wbw-zoom-hud-top');
      panel.style.removeProperty('top');
      panel.style.removeProperty('max-height');
      panel.style.setProperty(
        '--wbw-zoom-hud-bottom',
        'calc(4.85rem + env(safe-area-inset-bottom, 0px))'
      );
      panel.style.bottom = 'calc(4.85rem + env(safe-area-inset-bottom, 0px))';
    }

    function mountWizardZoomHud(variantId, sectionId) {
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      if (!v) return;
      if (!isWizardZoomUiOpen(sectionId) && !document.querySelector('[data-wbw-image-zoom]')) return;

      document.querySelectorAll('[data-wbw-zoom-hud]').forEach(function (el) {
        el.remove();
      });
      if (zoomHudTeardown) {
        zoomHudTeardown();
        zoomHudTeardown = null;
      }

      var lastActiveMediaId = '';
      var slideSyncReady = false;
      var sectionRoot = getSectionRoot(wizardRoot, data);
      var styleIdxOpen =
        data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      ensureVariantMediaMeta(v, sectionRoot, styleIdxOpen);
      var openedMediaId = String(v.featured_media_id || '');
      lastActiveMediaId = openedMediaId;

      function paintHudContent() {
        var current = findWizardVariant(id);
        if (!current) return;
        var qty = state.variantQty[id] || 0;
        var label = current.label || current.title || 'Workshop';
        var priceHtml = formatWizardVariantPricesOuter(current, state.selectedSlot);
        var labelEl = hud.querySelector('.wbw-zoom-hud__variant');
        if (labelEl) labelEl.textContent = label;
        var qtyEl = hud.querySelector('[data-wbw-zoom-qty-val]');
        if (qtyEl) qtyEl.textContent = String(qty);
        var priceEl = hud.querySelector('.wbw-zoom-hud__price');
        if (priceEl) priceEl.innerHTML = priceHtml;
        hud.setAttribute('data-wbw-zoom-variant-id', id);
      }

      function syncHudFromActiveZoomSlide() {
        if (!slideSyncReady) return;
        var mediaId = getActiveZoomMediaId(sectionId);
        if (!mediaId || mediaId === lastActiveMediaId) return;
        lastActiveMediaId = mediaId;
        var mapped = findWizardVariantForZoomMedia(mediaId, sectionId, sectionRoot);
        /* Unowned detail shots keep current HUD. */
        if (!mapped) return;
        var nextId = vQtyKey(mapped.id);
        if (nextId === id) {
          paintHudContent();
          return;
        }
        id = nextId;
        previewWizardVariant(id, { syncPdp: false, scrollCarousel: false });
        paintHudContent();
      }

      function armSlideSync() {
        if (slideSyncReady) return;
        slideSyncReady = true;
        var nowId = getActiveZoomMediaId(sectionId);
        /*
         * Anchor to whatever the gallery reports now WITHOUT rewriting HUD.
         * Calling sync here stole the title back to the first slide (Candle Holder)
         * when thumbs lagged behind the opened variant image.
         */
        if (nowId) {
          var mappedNow = findWizardVariantForZoomMedia(nowId, sectionId, sectionRoot);
          if (mappedNow && vQtyKey(mappedNow.id) === id) {
            lastActiveMediaId = nowId;
          } else {
            lastActiveMediaId = nowId;
          }
        } else if (openedMediaId) {
          lastActiveMediaId = openedMediaId;
        }
      }

      var qty = state.variantQty[id] || 0;
      var label = v.label || v.title || 'Workshop';
      var priceHtml = formatWizardVariantPricesOuter(v, state.selectedSlot);
      var dateKey = state.selectedSlot ? slotDateKey(state.selectedSlot) : '';
      var dateLabel = dateKey ? formatPopupDateLabel(dateKey) : '';
      var timeLabel = state.selectedSlot ? formatSessionTimeRange(state.selectedSlot.time_label) : '';
      var hud = document.createElement('div');
      hud.className = 'wbw-zoom-hud';
      hud.setAttribute('data-wbw-zoom-hud', '');
      hud.setAttribute('data-wbw-zoom-variant-id', id);
      hud.innerHTML =
        '<div class="wbw-zoom-hud__bottom">' +
        '<div class="wbw-zoom-hud__variant">' +
        escapeHtml(label) +
        '</div>' +
        '<div class="wbw-zoom-hud__buy">' +
        '<div class="wbw-zoom-hud__qty" role="group" aria-label="Quantity">' +
        '<button type="button" class="wbw-zoom-hud__qty-btn" data-wbw-zoom-qty-dec aria-label="Decrease quantity">&minus;</button>' +
        '<span class="wbw-zoom-hud__qty-val" data-wbw-zoom-qty-val>' +
        escapeHtml(String(qty)) +
        '</span>' +
        '<button type="button" class="wbw-zoom-hud__qty-btn" data-wbw-zoom-qty-inc aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<div class="wbw-zoom-hud__price">' +
        priceHtml +
        '</div>' +
        '</div>' +
        '<div class="wbw-zoom-hud__when-row">' +
        (dateLabel
          ? '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--date"><span class="wbw-zoom-hud__when-label">Date</span><span class="wbw-zoom-hud__when-value">' +
            escapeHtml(dateLabel) +
            '</span></div>'
          : '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--muted wbw-zoom-hud__when--date"><span class="wbw-zoom-hud__when-label">Date</span><span class="wbw-zoom-hud__when-value">Not selected</span></div>') +
        (timeLabel
          ? '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--time"><span class="wbw-zoom-hud__when-label">Time</span><span class="wbw-zoom-hud__when-value">' +
            escapeHtml(timeLabel) +
            '</span></div>'
          : '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--muted wbw-zoom-hud__when--time"><span class="wbw-zoom-hud__when-label">Time</span><span class="wbw-zoom-hud__when-value">Not selected</span></div>') +
        '</div>' +
        '</div>';

      hud.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      hud.addEventListener(
        'touchstart',
        function (e) {
          e.stopPropagation();
        },
        { passive: true }
      );

      function onQtyDelta(delta, e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (!wizardZoomQtyAllowed()) return;
        closeWizardZoomOverlay(sectionId);
        adjustVariantQty(id, delta);
      }

      var inc = hud.querySelector('[data-wbw-zoom-qty-inc]');
      var dec = hud.querySelector('[data-wbw-zoom-qty-dec]');
      if (inc) {
        inc.addEventListener('click', function (e) {
          onQtyDelta(1, e);
        });
      }
      if (dec) {
        dec.addEventListener('click', function (e) {
          onQtyDelta(-1, e);
        });
      }

      mountHudIntoZoomChrome(hud, sectionId);
      positionWizardZoomHudPanel(hud);
      window.setTimeout(armSlideSync, 480);
      window.setTimeout(function () {
        positionZoomGalleryArrows(sectionId);
      }, 100);
      window.setTimeout(function () {
        positionZoomGalleryArrows(sectionId);
      }, 320);

      function onZoomDismiss() {
        teardownWizardZoomHud();
      }

      function onDocEsc(e) {
        if (e.key === 'Escape') onZoomDismiss();
      }

      function onViewportChange() {
        positionZoomGalleryArrows(sectionId);
      }

      function onGallerySlideChange() {
        var wasReady = slideSyncReady;
        armSlideSync();
        if (!wasReady) {
          /* User moved before the arm timer — sync to the slide they landed on. */
          lastActiveMediaId = '';
        }
        syncHudFromActiveZoomSlide();
        positionZoomGalleryArrows(sectionId);
      }

      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      var closeBtn = sectionId ? document.getElementById('ProductModalClose-' + sectionId) : null;
      var gallery = sectionId ? document.getElementById('media-gallery-' + sectionId) : null;
      var thumbsRoot = findWizardZoomThumbnailEl(sectionId);
      if (closeBtn) closeBtn.addEventListener('click', onZoomDismiss);
      document.addEventListener('keydown', onDocEsc);
      window.addEventListener('resize', onViewportChange);
      window.addEventListener('orientationchange', onViewportChange);

      if (gallery && gallery.splide && typeof gallery.splide.on === 'function') {
        gallery.splide.on('moved', onGallerySlideChange);
        gallery.splide.on('move', onGallerySlideChange);
      }
      if (thumbsRoot) {
        thumbsRoot.addEventListener('click', onGallerySlideChange);
      }

      var observer = null;
      if (modal && typeof MutationObserver === 'function') {
        observer = new MutationObserver(function () {
          if (!isWizardZoomUiOpen(sectionId)) teardownWizardZoomHud();
          else syncHudFromActiveZoomSlide();
        });
        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
          subtree: true,
        });
      }

      var watchId = window.setInterval(function () {
        if (!isWizardZoomUiOpen(sectionId) && !document.querySelector('[data-wbw-image-zoom]')) {
          teardownWizardZoomHud();
        } else {
          syncHudFromActiveZoomSlide();
        }
      }, 120);

      function onFallbackClosed() {
        teardownWizardZoomHud();
      }
      document.addEventListener('wbw:image-zoom-closed', onFallbackClosed);

      zoomHudTeardown = function () {
        window.clearInterval(watchId);
        document.removeEventListener('wbw:image-zoom-closed', onFallbackClosed);
        document.removeEventListener('keydown', onDocEsc);
        window.removeEventListener('resize', onViewportChange);
        window.removeEventListener('orientationchange', onViewportChange);
        if (closeBtn) closeBtn.removeEventListener('click', onZoomDismiss);
        if (thumbsRoot) thumbsRoot.removeEventListener('click', onGallerySlideChange);
        if (gallery) {
          gallery.classList.remove('wbw-zoom-gallery--with-hud');
          gallery.querySelectorAll('.splide__arrow').forEach(function (btn) {
            btn.style.top = '';
            btn.style.marginTop = '';
            btn.style.transform = '';
            btn.style.left = '';
            btn.style.right = '';
          });
          if (gallery.splide && typeof gallery.splide.off === 'function') {
            gallery.splide.off('moved', onGallerySlideChange);
            gallery.splide.off('move', onGallerySlideChange);
          }
        }
        if (observer) observer.disconnect();
        if (hud.parentNode) hud.remove();
      };
    }

    function previewWizardVariant(variantId, options) {
      var opts = options || {};
      var syncPdp = opts.syncPdp !== false;
      var scrollCarousel = opts.scrollCarousel !== false;
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      state.focusedVariantId = id;
      /* Shared date/time stays on the main dropdown; per-design times live in variantWhen. */
      syncVariantToolbar();
      if (v && syncPdp) syncVariantToPdp(wizardRoot, data, v);
      syncBookingUrlVariantOnStep3(id);
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (wrap) {
        wrap.querySelectorAll('.wcf-variant-row').forEach(function (row) {
          var rid = row.getAttribute('data-variant-id') || '';
          var on = rid === id && !(state.variantQty[id] > 0);
          row.classList.toggle('is-preview', on);
          if (scrollCarousel && rid === id) {
            /* Scroll only the carousel track — scrollIntoView also moves the PDP gallery. */
            if (wrap.classList.contains('wcf-variants--carousel')) {
              animateCarouselScrollLeft(wrap, carouselSlideScrollLeft(wrap, row), 420);
            } else {
              var left = row.offsetLeft - (wrap.clientWidth - row.offsetWidth) / 2;
              wrap.scrollTo({
                left: Math.max(0, left),
                behavior: 'smooth',
              });
            }
          }
        });
      }
    }

    function findWizardVariant(id) {
      var key = vQtyKey(id);
      if (addonVariantIdKey && key === addonVariantIdKey) return addonVariantObject();
      for (var i = 0; i < variants.length; i++) {
        if (vQtyKey(variants[i].id) === key) return variants[i];
      }
      return null;
    }

    function refreshAllVariantRowsForSlot() {
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return false;
      var rows = wrap.querySelectorAll('.wcf-variant-row[data-variant-id]');
      if (!rows.length) return false;

      var slot = state.selectedSlot;
      var popupPreSlot =
        !slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
      var eventOpen = slotBookable(slot) || popupPreSlot;
      var popupVenue = !!(state.selectedVenue && !isStoreVenue(state.selectedVenue));

      rows.forEach(function (row) {
        var id = String(row.getAttribute('data-variant-id') || '');
        if (!id) return;
        if (!eventOpen && !popupVenue) row.classList.add('is-disabled');
        else row.classList.remove('is-disabled');
        refreshVariantRowUI(id);
      });
      updateVariantStepUi();
      syncVariantToolbar();
      return true;
    }

    function refreshVariantRowUI(variantId) {
      var id = vQtyKey(variantId);
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      var row = wrap.querySelector('.wcf-variant-row[data-variant-id="' + id + '"]');
      if (!row) return;
      var qty = state.variantQty[id] || 0;
      row.classList.toggle('is-active', qty > 0);
      row.classList.toggle(
        'is-preview',
        state.focusedVariantId === id && qty <= 0
      );
      var val = row.querySelector('[data-wbw-qty-val]');
      if (val) val.textContent = String(qty);
      var dec = row.querySelector('[data-wbw-qty-dec]');
      if (dec) dec.disabled = qty <= 0;
      var inc = row.querySelector('[data-wbw-qty-inc]');
      if (inc) {
        var maxTotal = maxBookableQty();
        if (isAddonVariantId(id)) {
          var addonQ = state.variantQty[id] || 0;
          inc.disabled = Number.isFinite(maxTotal) && addonQ >= maxTotal;
        } else {
          inc.disabled = Number.isFinite(maxTotal) && totalVariantQty(false) >= maxTotal;
        }
      }
      var card = row.querySelector('.wcf-variant-card');
      if (card) card.classList.toggle('is-active', qty > 0);
      var buyRow = row.querySelector('.wbw-variant-buy-row');
      if (buyRow) buyRow.hidden = qty <= 0;
      var vObj = findWizardVariant(id);
      if (vObj) {
        var pricesWrap = row.querySelector('.wcf-variant-card__prices');
        if (pricesWrap) {
          pricesWrap.outerHTML = formatWizardVariantPricesOuter(
            vObj,
            resolveVariantSlot(id) || state.selectedSlot
          );
        }
      }
    }

    function adjustVariantQty(variantId, delta) {
      clearWizardNotice();
      var id = vQtyKey(variantId);
      var cur = state.variantQty[id] || 0;
      var maxTotal = maxBookableQty();
      var isAddon = isAddonVariantId(id);
      var others = isAddon ? cur : totalVariantQty(false) - cur;
      var v = findWizardVariant(id);
      var wasZero = !(cur > 0);

      if (delta > 0) {
        if (isAddon) {
          if (Number.isFinite(maxTotal) && cur >= maxTotal) return;
          state.variantQty[id] = Number.isFinite(maxTotal) ? Math.min(cur + 1, maxTotal) : cur + 1;
        } else {
          if (others >= maxTotal) return;
          state.variantQty[id] = Math.min(cur + 1, maxTotal - others);
          state.focusedVariantId = id;
          state.lockedVariantId = id;
        }
      } else {
        if (cur <= 1) delete state.variantQty[id];
        else state.variantQty[id] = cur - 1;
        if (!isAddon && (state.variantQty[id] || 0) > 0) {
          state.focusedVariantId = id;
          state.lockedVariantId = id;
        }
      }
      refreshVariantRowUI(id);
      syncVariantToolbar();
      updateVariantStepUi();
      if (!isAddon && v && (delta > 0 || (state.variantQty[id] || 0) > 0)) {
        syncVariantToPdp(wizardRoot, data, v);
        syncBookingUrlVariantOnStep3(id);
      }
      if (!isAddon && wasZero && delta > 0 && (state.variantQty[id] || 0) > 0) {
        try {
          var wbwSel = global.WorkshopBookingWizardAnalytics;
          if (wbwSel && typeof wbwSel.trackUser === 'function') {
            wbwSel.trackUser('design', 'wbw_design_select', state, wizardRoot, data, {
              wbw_variant_id: id,
              wbw_variant_title: String((v && (v.label || v.title)) || ''),
              wbw_qty: state.variantQty[id] || 0,
              wbw_source: 'variant_qty',
            });
          }
        } catch (_) {}
      }
    }

    function computeTotalCents() {
      var total = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = findWizardVariant(k);
        if (v) total += resolveVariantPriceCents(v, resolveVariantSlot(k) || state.selectedSlot) * q;
      });
      return total;
    }

    function updateVariantStepUi() {
      var titleHead = wizardRoot.querySelector('[data-wbw-variant-title-head]');
      var titleEl = wizardRoot.querySelector('[data-wbw-variant-title]');
      if (titleHead) titleHead.hidden = false;
      if (titleEl) titleEl.textContent = 'Select a design';
      var tot = wizardRoot.querySelector('[data-wbw-total]');
      if (tot) {
        var cents = computeTotalCents();
        tot.textContent = formatMoney(cents);
      }
      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      if (addBtn) addBtn.disabled = !hasSelectedVariants() || !allSelectedVariantsHaveSlot();
      syncAtcReminder();
      var hasAnyQty = false;
      Object.keys(state.variantQty).forEach(function (k) {
        if (state.variantQty[k] > 0) hasAnyQty = true;
      });
      wizardRoot.querySelectorAll('[data-wbw-action="clear-selection"]').forEach(function (clearBtn) {
        clearBtn.disabled = !hasAnyQty;
        if (hasAnyQty) clearBtn.removeAttribute('hidden');
        else clearBtn.setAttribute('hidden', '');
      });
      updateSelectionSummary();
      syncVariantToolbar();
      syncSiblingWorkshopPromo();
    }

    function firstNonEmptyStr() {
      for (var i = 0; i < arguments.length; i++) {
        var s = arguments[i] == null ? '' : String(arguments[i]).trim();
        if (s) return s;
      }
      return '';
    }

    function resolveSlotEventId(slot) {
      var raw = (slot && slot._raw) || {};
      return String(
        raw.id ||
          raw.event_id ||
          raw.event_metaobject_gid ||
          raw.gid ||
          (slot && slot.gid) ||
          ''
      ).trim();
    }

    function buildLineItemProperties(slot, variantId, resolvedCents) {
      var raw = (slot && slot._raw) || {};
      var venueObj = state.selectedVenue || {};
      var eventId = resolveSlotEventId(slot);
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      var venue = String(raw.venue_name || raw.venue || venueObj.venue_name || '').trim();
      var city = String(raw.city || '').trim();
      var stateCode = String(raw.state || '').trim();
      var datetime = formatBookingSubLabel(slot);
      var displayCity = stateCode ? city + ', ' + stateCode : city;
      // Slot event first, then selected venue object (same selection context — not a silent default)
      var venueAddress = firstNonEmptyStr(
        raw.venue_address,
        raw.address,
        venueObj.venue_address,
        venueObj.address
      );
      var venuePhone = firstNonEmptyStr(raw.venue_phone, raw.phone, venueObj.venue_phone, venueObj.phone);
      var venueHours = firstNonEmptyStr(
        raw.venue_work_hours,
        raw.work_hours,
        venueObj.venue_work_hours,
        venueObj.work_hours
      );
      var props = {
        _workshop: 'true',
        _event_handle: eventHandle,
        _display_city: displayCity,
        _display_venue: venue,
        _display_datetime: datetime,
        _is_workshop: '1',
      };
      if (eventId) {
        props._event_id = eventId;
        props._event_metaobject_gid = eventId.indexOf('gid://') === 0 ? eventId : slot.gid || eventId;
        var groupId = String(
          slot.capacity_group_id || raw.capacity_group_id || slot.canonical_event_id || raw.canonical_event_id || ''
        ).trim();
        if (groupId) props._capacity_group_id = groupId;
        var canonicalId = String(slot.canonical_event_id || raw.canonical_event_id || '').trim();
        if (canonicalId) props._canonical_event_id = canonicalId;
        props._unique = String(variantId) + ':' + eventId;
        var bookingDetails = [venue, datetime].filter(Boolean).join(' · ');
        if (bookingDetails) props['Booking Details'] = bookingDetails;
      }
      if (venueAddress) props._venue_address = venueAddress;
      if (venuePhone) props._venue_phone = venuePhone;
      if (venueHours) props._venue_hours = venueHours;
      var slotForValidation = Object.assign({}, slot, { gid: slot.gid || eventId });
      var flow = window.WorkshopCityFlow;
      if (flow && typeof flow.appendCartValidationProperties === 'function') {
        props = flow.appendCartValidationProperties(slotForValidation, props);
      } else {
        var cap = slot && slot.capacity_remaining;
        if (cap != null && cap !== '') {
          var cn = Number(cap);
          if (Number.isFinite(cn) && cn >= 0) {
            props._capacity_remaining = String(cn);
            props._capacity_source = 'wizard_slot';
          }
        }
      }
      var centsStr = String(resolvedCents == null ? '' : resolvedCents).trim();
      if (/^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0) {
        props._resolved_price_cents = centsStr;
        props._resolved_price = centsStr;
      }
      return props;
    }

    var wlFieldErrorTimers = {};

    function clearWlFieldErrors(step) {
      if (!step) return;
      step.querySelectorAll('[data-wbw-wl-field-hint]').forEach(function (hint) {
        hint.hidden = true;
        hint.textContent = '';
      });
      step.querySelectorAll('.wcf-field--err').forEach(function (field) {
        field.classList.remove('wcf-field--err');
      });
    }

    function showWlFieldError(input, message) {
      if (!input || !message) return;
      var field = input.closest('.wcf-field');
      if (!field) return;
      var key =
        input.getAttribute('data-wbw-wl-name') || input.getAttribute('data-wbw-wl-modal-name')
          ? 'name'
          : input.getAttribute('data-wbw-wl-email') || input.getAttribute('data-wbw-wl-modal-email')
            ? 'email'
            : 'other';
      if (wlFieldErrorTimers[key]) {
        clearTimeout(wlFieldErrorTimers[key]);
        wlFieldErrorTimers[key] = null;
      }
      var hint = field.querySelector('[data-wbw-wl-field-hint]');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'wcf-field-hint wcf-field-hint--err';
        hint.setAttribute('data-wbw-wl-field-hint', '');
        hint.setAttribute('role', 'alert');
        field.appendChild(hint);
      }
      hint.textContent = message;
      hint.hidden = false;
      field.classList.add('wcf-field--err');
      input.setAttribute('aria-invalid', 'true');
      wlFieldErrorTimers[key] = window.setTimeout(function () {
        hint.hidden = true;
        hint.textContent = '';
        field.classList.remove('wcf-field--err');
        input.removeAttribute('aria-invalid');
        wlFieldErrorTimers[key] = null;
      }, 2000);
    }

    function submitWaitlist() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal].is-open');
      var step = modal || stepEl('waitlist');
      if (!step) return;
      var nameIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-name]' : '[data-wbw-wl-name]'
      );
      var emailIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-email]' : '[data-wbw-wl-email]'
      );
      var notesIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-notes]' : '[data-wbw-wl-notes]'
      );
      var errEl = step.querySelector(modal ? '[data-wbw-wl-modal-error]' : '[data-wbw-wl-error]');
      var okEl = step.querySelector(modal ? '[data-wbw-wl-modal-success]' : '[data-wbw-wl-success]');
      var subBtn = modal
        ? modal.querySelector('[data-wbw-action="wl-submit"]')
        : step.querySelector('[data-wbw-action="wl-submit"]');
      if (errEl) errEl.hidden = true;
      if (okEl) okEl.hidden = true;
      clearWlFieldErrors(step);

      var fullName = nameIn ? String(nameIn.value || '').trim() : '';
      var email = emailIn ? String(emailIn.value || '').trim() : '';
      var notes = notesIn ? String(notesIn.value || '').trim() : '';
      var parts = splitFullName(fullName);

      if (!fullName) {
        showWlFieldError(nameIn, 'Please enter your name.');
        if (nameIn && nameIn.focus) nameIn.focus();
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showWlFieldError(emailIn, 'Please enter a valid email.');
        if (emailIn && emailIn.focus) emailIn.focus();
        return;
      }

      var venue = state.selectedVenue || {};
      var venueRefId = venue.venue_ref_id != null ? String(venue.venue_ref_id).trim() : '';
      var venueTitle = (venue.venue_name || venue.name || '').trim();
      var loc = (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.label) || '';
      if (!loc && bookingRoot) {
        var inp = bookingRoot.querySelector('[data-workshop-location-input]');
        if (inp) loc = String(inp.value || '').trim();
      }
      var cityForAddress = '';
      if (loc) {
        var addrParts = loc.split(',');
        if (addrParts[0]) cityForAddress = String(addrParts[0]).trim();
      }
      if (!cityForAddress && venueTitle) cityForAddress = venueTitle;

      if (subBtn) subBtn.disabled = true;

      resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data)
        .then(function (workshopType) {
          if (!workshopType) {
            throw new Error(
              'Workshop type could not be determined. Add a product tag (mosaic, ceramic, resin, or flower) or set Workshop type in the booking block settings.'
            );
          }

          var shopDomain = window.Shopify && window.Shopify.shop ? String(window.Shopify.shop).trim() : '';
          var myshopifyDomain = '';
          if (/\.myshopify\.com$/i.test(shopDomain)) myshopifyDomain = shopDomain;
          if (!myshopifyDomain) {
            try {
              var pfShopDomain =
                window.__pagefly_setting__ &&
                window.__pagefly_setting__.shopDomain
                  ? String(window.__pagefly_setting__.shopDomain).trim()
                  : '';
              if (/\.myshopify\.com$/i.test(pfShopDomain)) myshopifyDomain = pfShopDomain;
            } catch (_) {}
          }
          var resolvedShopDomain = myshopifyDomain || shopDomain;
          var bookingCtx =
            typeof window.wbBuildAogenBookingContext === 'function'
              ? window.wbBuildAogenBookingContext(venue, bookingRoot, { intent: 'inline' })
              : {};
          var submitted = {
            email: email,
            name: fullName,
            consent: true,
            venue_id: venueRefId,
            venue_name: venueTitle,
            city: bookingCtx.city || cityForAddress,
            state: bookingCtx.state || '',
            country: bookingCtx.country || 'USA',
            workshop_type: workshopType,
            product_id: bookingCtx.product_id || '',
            product_name: bookingCtx.product_name || '',
            product_handle: bookingCtx.product_handle || '',
            page_url: window.location.href,
          };
          if (notes) submitted.notes = notes;

          var formsBase =
            typeof window.__WB_FORMS_API_BASE__ === 'string' && window.__WB_FORMS_API_BASE__.trim()
              ? window.__WB_FORMS_API_BASE__.trim().replace(/\/+$/, '')
              : 'https://adapter.aogen.com.au';
          var url = formsBase + '/api/public/forms/submit';
          var payload = {
            shop: resolvedShopDomain,
            form_key: window.__WB_FORMS_FORM_KEY__ || 'waitlist',
            submitted_data: submitted,
            source_url: window.location.href,
          };

          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
            mode: 'cors',
          }).then(function (res) {
            return res.text().then(function (text) {
              var body = null;
              if (text) {
                try {
                  body = JSON.parse(text);
                } catch (_) {
                  body = null;
                }
              }
              if (!res.ok || !body || body.ok !== true) {
                var msg =
                  (body &&
                    (body.error ||
                      body.message ||
                      (Array.isArray(body.details) && body.details[0] && body.details[0].message))) ||
                  'Request failed (' + res.status + ')';
                throw new Error(String(msg));
              }
              return body;
            });
          });
        })
        .then(function () {
          if (okEl) okEl.hidden = false;
          if (modal) {
            window.setTimeout(function () {
              closeWizardWaitlistModal();
            }, 2200);
          }
        })
        .catch(function (err) {
          if (errEl) {
            errEl.textContent = err && err.message ? String(err.message).slice(0, 200) : 'Something went wrong.';
            errEl.hidden = false;
          }
        })
        .finally(function () {
          if (subBtn) subBtn.disabled = false;
        });
    }

    function submitCartForSlot(slot, addBtn, onlyVariantId) {
      var coralVenue =
        state.selectedVenue && state.selectedVenue._coral_hub ? state.selectedVenue : null;
      var CoralHub = typeof window !== 'undefined' ? window.WorkshopBookingCoralHub : null;
      var ensureVariants =
        coralVenue && CoralHub && typeof CoralHub.prefetchSellVariants === 'function'
          ? CoralHub.prefetchSellVariants(coralVenue)
          : Promise.resolve(coralVenue);

      return ensureVariants.then(function () {
      var items = [];
      var workshopRows = [];
      var onlyId = onlyVariantId ? vQtyKey(onlyVariantId) : '';
      var keys = onlyId ? [onlyId] : Object.keys(state.variantQty);
      var addonEventSlot = slot || state.selectedSlot;
      var bad = false;
      keys.forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var vid = parseInt(k, 10);
        if (!Number.isFinite(vid) || vid <= 0) return;
        var v = findWizardVariant(k);
        if (!onlyId && isAddonVariantId(k)) {
          items.push({
            id: vid,
            quantity: q,
            properties: {
              _workshop_addon: 'true',
              _addon_for_event_id: resolveSlotEventId(addonEventSlot),
              _addon_title: wbwAddonDisplayTitle(wizardRoot),
            },
          });
          return;
        }
        if (onlyId && isAddonVariantId(k)) return;
        var lineSlot = onlyId ? slot || resolveVariantSlot(k) : resolveVariantSlot(k);
        if (!lineSlot || !slotBookable(lineSlot)) {
          bad = true;
          return;
        }
        var resolved = v ? resolveVariantPriceCents(v, lineSlot) : 0;
        var handle = String((lineSlot._raw && lineSlot._raw.handle) || lineSlot.handle || '');
        var eventIdForLine = resolveSlotEventId(lineSlot);
        // events-batch thin slots may omit handle until adapter ships it; coral ATC needs event_id.
        if ((!handle || /^\d+$/.test(handle)) && !(coralVenue && eventIdForLine)) {
          bad = true;
          return;
        }
        /** Coral hub: cart the city product variant (title-matched), not the hub SKU. */
        if (coralVenue && CoralHub && typeof CoralHub.remapHubVariantId === 'function') {
          var sellId = CoralHub.remapHubVariantId(
            coralVenue,
            String(vid),
            (v && (v.label || v.title)) || ''
          );
          var sellNum = parseInt(sellId, 10);
          if (Number.isFinite(sellNum) && sellNum > 0) vid = sellNum;
          else {
            bad = true;
            return;
          }
        }
        var properties = buildLineItemProperties(lineSlot, vid, resolved);
        if (!properties._event_id) {
          bad = true;
          return;
        }
        workshopRows.push({
          vid: vid,
          q: q,
          properties: properties,
          cents: Number(resolved) || Number.POSITIVE_INFINITY,
        });
      });
      // Function discounts cheapest unit only → split only that SKU (carrier $0 + stack);
      // other SKUs stay one merged line (Short Table ×2 style).
      var cheapestIdx = -1;
      var cheapestCents = Number.POSITIVE_INFINITY;
      workshopRows.forEach(function (row, idx) {
        if (row.cents < cheapestCents) {
          cheapestCents = row.cents;
          cheapestIdx = idx;
        }
      });
      var freeTail = [];
      workshopRows.forEach(function (row, idx) {
        var seatBase = String(row.properties._unique || '').replace(/:seat:.*$/, '');
        if (!seatBase) {
          seatBase =
            String(row.vid) +
            ':' +
            String(row.properties._event_metaobject_gid || row.properties._event_id || 'seat');
        }
        var splitThis = idx === cheapestIdx && row.q >= 2;
        if (!splitThis) {
          var merged = Object.assign({}, row.properties);
          merged._unique = seatBase;
          items.push({ id: row.vid, quantity: row.q, properties: merged });
          return;
        }
        // Paid stack first; free base deferred to end of payload (Function → newest = $0).
        var paidProps = Object.assign({}, row.properties);
        paidProps._unique = seatBase + ':seat:stack';
        items.push({ id: row.vid, quantity: row.q - 1, properties: paidProps });
        var freeProps = Object.assign({}, row.properties);
        freeProps._unique = seatBase;
        freeTail.push({ id: row.vid, quantity: 1, properties: freeProps });
      });
      freeTail.forEach(function (it) {
        items.push(it);
      });
      if (bad) {
        showWizardNotice(
          'This workshop event is not available for booking. Please select a different time.',
          { force: true }
        );
        updateVariantStepUi();
        return false;
      }
      if (!items.length) {
        showWizardNotice('Unable to add to cart. Please check your selection and try again.', { force: true });
        return false;
      }

      var payload = { items: items };
      if (Flow && Flow.getCartSections) {
        var sections = Flow.getCartSections();
        if (sections.length) {
          payload.sections = sections.join(',');
          payload.sections_url = (window.location && window.location.pathname) || '/';
        }
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (r) {
          if (!r.ok || (r.body && r.body.status === 422)) {
            showWizardNotice((r.body && r.body.description) || 'Unable to add to cart.', { force: true });
            try {
              var wbwRej = global.WorkshopBookingWizardAnalytics;
              if (wbwRej && typeof wbwRej.track === 'function') {
                wbwRej.track('wbw_add_to_cart_error', state, wizardRoot, data, {
                  error_type: 'cart_add_rejected',
                });
              }
            } catch (_) {}
            return false;
          }
          if (Flow && Flow.dispatchCartUi) Flow.dispatchCartUi(r.body);
          try {
            if (
              global.WorkshopCityCartLive &&
              typeof global.WorkshopCityCartLive.splitMergedWorkshopLines === 'function'
            ) {
              global.WorkshopCityCartLive.splitMergedWorkshopLines();
            }
          } catch (_) {}
          try {
            var wbwOk = global.WorkshopBookingWizardAnalytics;
            var selectedIds = [];
            var qtyTotal = 0;
            Object.keys(state.variantQty).forEach(function (k) {
              var q = state.variantQty[k] || 0;
              if (!q || isAddonVariantId(k)) return;
              selectedIds.push(k);
              qtyTotal += q;
            });
            if (wbwOk && typeof wbwOk.markConverted === 'function') wbwOk.markConverted();
            if (wbwOk && typeof wbwOk.track === 'function') {
              wbwOk.track('wbw_add_to_cart', state, wizardRoot, data, {
                wbw_design_count: selectedIds.length,
                wbw_qty_total: qtyTotal,
                wbw_variant_ids: selectedIds.join(','),
              });
            }
            if (wbwOk && typeof wbwOk.resetFunnel === 'function') wbwOk.resetFunnel();
          } catch (_) {}
          resetWizardAfterSuccessfulAtc();
          /* Stay on PDP — open mini cart only (no /cart redirect). */
          return true;
        })
        .catch(function () {
          try {
            var wbwEx = global.WorkshopBookingWizardAnalytics;
            if (wbwEx && typeof wbwEx.track === 'function') {
              wbwEx.track('wbw_add_to_cart_error', state, wizardRoot, data, {
                error_type: 'cart_add_exception',
              });
            }
          } catch (_) {}
          showWizardNotice('Unable to add to cart.', { force: true });
          return false;
        });
      });
    }

    function addLightboxToCart(box) {
      persistLightboxWhen(box);
      var id = lightboxVariantId(box);
      /* Via adjustVariantQty so 0→1 fires wbw_design_select */
      if (id && !(state.variantQty[id] > 0)) adjustVariantQty(id, 1);
      paintWizardLightbox(box);
      updateVariantStepUi();
      addToCart();
    }

    function validateSlotQty(slot, qty, extra) {
      extra = extra || {};
      if (liveController && typeof liveController.validateSlotForCart === 'function') {
        return liveController.validateSlotForCart(slot, qty, extra);
      }
      var liveApi = getLiveApi();
      if (liveApi && typeof liveApi.validateAddToCart === 'function') {
        return liveApi.validateAddToCart(slot, qty, Object.assign({ intent: 'add_to_cart' }, extra));
      }
      var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
      if (CFG && typeof CFG.verifySoftMode === 'function' && CFG.verifySoftMode()) {
        return Promise.resolve({ allowed: true, skipped_validation: true });
      }
      return Promise.resolve({
        allowed: false,
        message: 'We could not verify workshop availability. Please try again.',
      });
    }

    function addToCart() {
      if (liveFlags.atcInFlight) return;
      if (!hasSelectedVariants()) {
        showWizardNotice('Please select a design.');
        return;
      }
      /* Group selected designs by their resolved slot (per-variant date/time wins). */
      var groups = {};
      var missing = false;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q || isAddonVariantId(k)) return;
        var s = resolveVariantSlot(k);
        if (!s || !slotBookable(s)) {
          missing = true;
          return;
        }
        var key = slotSyncKey(s);
        if (!groups[key]) groups[key] = { slot: s, qty: 0 };
        groups[key].qty += q;
      });
      var groupKeys = Object.keys(groups);
      if (missing || !groupKeys.length) {
        showWizardNotice('Please select a date and time.');
        updateVariantStepUi();
        return;
      }

      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      var lbBtn = document.querySelector('[data-wbw-lb-add]');
      function setAddBusy(on) {
        [addBtn, lbBtn].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = on ? true : !hasSelectedVariants() || !allSelectedVariantsHaveSlot();
          btn.textContent = on ? 'Adding…' : 'Add to cart';
        });
      }
      setAddBusy(true);
      liveFlags.atcInFlight = true;

      function slotCapacityPoolKey(slot) {
        var liveApi = getLiveApi();
        if (liveApi && typeof liveApi.capacityPoolKeyFromSlot === 'function') {
          var fromApi = liveApi.capacityPoolKeyFromSlot(slot);
          if (fromApi) return String(fromApi);
        }
        var raw = slot && slot._raw && typeof slot._raw === 'object' ? slot._raw : {};
        return String(
          (slot && (slot.capacity_group_id || slot.canonical_event_id)) ||
            raw.capacity_group_id ||
            raw.canonical_event_id ||
            slotSyncKey(slot) ||
            ''
        ).trim();
      }

      var pools = {};
      groupKeys.forEach(function (key) {
        var g = groups[key];
        var pk = slotCapacityPoolKey(g.slot) || key;
        if (!pools[pk]) pools[pk] = { slot: g.slot, qty: 0 };
        pools[pk].qty += g.qty;
      });
      var poolKeys = Object.keys(pools);
      var liveApi = getLiveApi();
      var cartPromise =
        liveApi && typeof liveApi.fetchCart === 'function' ? liveApi.fetchCart() : Promise.resolve(null);

      var chain = cartPromise.then(function (cart) {
        return checkCartSoldOutBeforeAdd(cart).then(function (cartBlockMsg) {
          if (cartBlockMsg) {
            showWizardNotice(cartBlockMsg, { force: true });
            return { ok: false };
          }
          return Promise.all(
            poolKeys.map(function (pk) {
              var extra = { intent: 'add_to_cart' };
              if (cart) extra.cart = cart;
              return validateSlotQty(pools[pk].slot, pools[pk].qty, extra);
            })
          ).then(function (verdicts) {
            var blockedMsg = '';
            for (var i = 0; i < verdicts.length; i++) {
              if (!verdicts[i] || verdicts[i].allowed !== false) continue;
              var pk = poolKeys[i];
              var slotForVerdict = (pools[pk] && pools[pk].slot) || state.selectedSlot;
              blockedMsg = rewriteAtcFailMessage(verdicts[i] && verdicts[i].message, slotForVerdict);
              break;
            }
            if (blockedMsg) {
              showWizardNotice(blockedMsg, { force: true });
              return { ok: false };
            }
            return { ok: true };
          });
        });
      });

      chain
        .then(function (result) {
          if (!result || result.ok !== true) return false;
          return submitCartForSlot(state.selectedSlot, addBtn);
        })
        .then(function (added) {
          if (added) {
            liveFlags.atcInFlight = false;
            setTimeout(function () {
              setAddBusy(false);
              if (typeof S.schedulePushRefresh === 'function') S.schedulePushRefresh();
            }, 1200);
            return;
          }
          // Not added (validate blocked or cart declined): resume live updates
          // and pull a fresh sweep so the calendar reflects why it was blocked.
          liveFlags.atcInFlight = false;
          setAddBusy(false);
          try {
            var wbwFail = global.WorkshopBookingWizardAnalytics;
            if (wbwFail && typeof wbwFail.track === 'function') {
              wbwFail.track('wbw_add_to_cart_error', state, wizardRoot, data, {
                error_type: 'blocked_or_declined',
              });
            }
          } catch (_) {}
          if (!String(state._wbwStickyNotice || '').trim()) {
            showWizardNotice('Unable to add to cart. Please try again.', { force: true });
          }
          updateVariantStepUi();
          sweepViewMonthLive({ force: true });
        })
        .catch(function () {
          liveFlags.atcInFlight = false;
          try {
            var wbwErr = global.WorkshopBookingWizardAnalytics;
            if (wbwErr && typeof wbwErr.track === 'function') {
              wbwErr.track('wbw_add_to_cart_error', state, wizardRoot, data, {
                error_type: 'exception',
              });
            }
          } catch (_) {}
          showWizardNotice('Unable to confirm workshop availability. Please try again.', { force: true });
          setAddBusy(false);
          updateVariantStepUi();
          sweepViewMonthLive({ force: true });
        });
    }

    if (!global.__WBW_CART_NOTICE_CLEAR__) {
      global.__WBW_CART_NOTICE_CLEAR__ = true;
      document.addEventListener('eurus:cart:items-changed', function () {
        clearStaleWizardCapacityNotice();
        syncAtcReminder();
      });
    }

      S.addToCart = addToCart;
      S.clearWizardNotice = clearWizardNotice;
      S.findSlotBySyncKey = findSlotBySyncKey;
      S.maxBookableQty = maxBookableQty;
      S.previewWizardVariant = previewWizardVariant;
      S.refreshOpenLightboxWhen = refreshOpenLightboxWhen;
      S.refreshAllVariantRowsForSlot = refreshAllVariantRowsForSlot;
      S.refreshVariantRowUI = refreshVariantRowUI;
      S.renderVariants = renderVariants;
      S.showWizardNotice = showWizardNotice;
      S.slotSyncKey = slotSyncKey;
      S.stampFocusedVariantWhenFromMain = stampFocusedVariantWhenFromMain;
      S.submitWaitlist = submitWaitlist;
      S.syncAtcReminder = syncAtcReminder;
      S.syncCapacityRing = syncCapacityRing;
      S.updateVariantStepUi = updateVariantStepUi;
    }
  };
})(typeof window !== "undefined" ? window : this);
